// Auto-generado desde COMERCIAL.xlsx
export const SEED_DATA = [
  {
    "id": 1,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "CONTACTOR 24V, 300A",
    "monto": 300000.0,
    "monto_iva": 57000.0,
    "monto_total": 357000.0,
    "fecha": "2025-11-13",
    "notas": "MAX GREDING",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "3",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 2,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "CODIFICADOR ENCODER 6206V",
    "monto": 152000.0,
    "monto_iva": 28880.0,
    "monto_total": 180880.0,
    "fecha": "2025-11-13",
    "notas": "MAX GREDING",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "3",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 3,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "JOYSTICK 1930ES JLG",
    "monto": 166386.0,
    "monto_iva": 31613.34,
    "monto_total": 197999.34,
    "fecha": "2025-12-18",
    "notas": "INMAQ",
    "rutContraparte": "77017003-6",
    "razonSocial": "INMAQ",
    "nFactura": "4",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 4,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS",
    "monto": 1038123.0,
    "monto_iva": 197243.37,
    "monto_total": 1235366.37,
    "fecha": "2025-12-30",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "7",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 5,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS",
    "monto": 1028044.0,
    "monto_iva": 195328.36000000002,
    "monto_total": 1223372.36,
    "fecha": "2025-12-30",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "8",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 6,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS",
    "monto": 1593439.0,
    "monto_iva": 302753.41000000003,
    "monto_total": 1896192.4100000001,
    "fecha": "2025-12-30",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "9",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 7,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS",
    "monto": 991981.0,
    "monto_iva": 188476.39,
    "monto_total": 1180457.3900000001,
    "fecha": "2026-01-12",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "10",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 8,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "CHIP INTELIGENTE",
    "monto": 498000.0,
    "monto_iva": 94620.0,
    "monto_total": 592620.0,
    "fecha": "2026-01-29",
    "notas": "VENDIDO A JUAN FERNANDEZ",
    "rutContraparte": "96792430-K",
    "razonSocial": "SODIMAC",
    "nFactura": "11",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 9,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS JLG",
    "monto": 933094.0,
    "monto_iva": 177287.86000000002,
    "monto_total": 1110381.86,
    "fecha": "2026-02-23",
    "notas": "MAX GREDING",
    "rutContraparte": "77388809-4",
    "razonSocial": "MAX GREDIG SER. MANT EIRL",
    "nFactura": "12",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 10,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS ENERO 26",
    "monto": 1368551.0,
    "monto_iva": 260024.69,
    "monto_total": 1628575.69,
    "fecha": "2026-02-25",
    "notas": "CUADRATURA 16/02",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "13",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 11,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS 01 AL 15 FEBRERO",
    "monto": 1368551.0,
    "monto_iva": 260024.69,
    "monto_total": 1628575.69,
    "fecha": "2026-02-25",
    "notas": "CUADRATURA 16/02",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "14",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 12,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRAJE 16/02",
    "monto": 1368551.0,
    "monto_iva": 260024.69,
    "monto_total": 1628575.69,
    "fecha": "2026-02-25",
    "notas": "CUADRATURA 16/02",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "15",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 13,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "ESLABONES DE CADENA",
    "monto": 627200.0,
    "monto_iva": 119168.0,
    "monto_total": 746368.0,
    "fecha": "2026-02-25",
    "notas": "SOLICITADO POR JUAN FERNANDEZ",
    "rutContraparte": "96792430-K",
    "razonSocial": "SODIMAC",
    "nFactura": "16",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 14,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS GRUA HORQUILLA 110D-7E",
    "monto": 627122.0,
    "monto_iva": 119153.18000000001,
    "monto_total": 746275.18,
    "fecha": "2026-02-25",
    "notas": "EQUIPO EN CORONEL",
    "rutContraparte": "96792430-K",
    "razonSocial": "SODIMAC",
    "nFactura": "17",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 15,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "CABLE DRIVE JLG",
    "monto": 298000.0,
    "monto_iva": 56620.0,
    "monto_total": 354620.0,
    "fecha": "2026-03-02",
    "notas": "CABLE DRIVE PARA UNIDS MOTRIC",
    "rutContraparte": "77388809-4",
    "razonSocial": "MAX GREDIG SER. MANT EIRL",
    "nFactura": "18",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 16,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "CHIP INTELIGENTE",
    "monto": 498000.0,
    "monto_iva": 94620.0,
    "monto_total": 592620.0,
    "fecha": "2026-03-12",
    "notas": "VENDIDO A JUAN FERNANDEZ",
    "rutContraparte": "96792430-K",
    "razonSocial": "SODIMAC",
    "nFactura": "19",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 17,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "JOYSTICK 1930ES JLG",
    "monto": 159207.0,
    "monto_iva": 30249.33,
    "monto_total": 189456.33000000002,
    "fecha": "2026-03-16",
    "notas": "PAGO AL CONTADO",
    "rutContraparte": "77659423-7",
    "razonSocial": "JARA & DIAZ SPA",
    "nFactura": "20",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 18,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 587358.0,
    "monto_iva": 111598.02,
    "monto_total": 698956.02,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "21",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 19,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 720131.0,
    "monto_iva": 136824.89,
    "monto_total": 856955.89,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "22",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 20,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 645104.0,
    "monto_iva": 122569.76,
    "monto_total": 767673.76,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "23",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 21,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 1129600.0,
    "monto_iva": 214624.0,
    "monto_total": 1344224.0,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "24",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 22,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 796342.0,
    "monto_iva": 151304.98,
    "monto_total": 947646.98,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "25",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 23,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 815632.0,
    "monto_iva": 154970.08000000002,
    "monto_total": 970602.0800000001,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "26",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 24,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 802112.0,
    "monto_iva": 152401.28,
    "monto_total": 954513.28,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "27",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 25,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 734872.0,
    "monto_iva": 139625.68,
    "monto_total": 874497.6799999999,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "28",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 26,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 970000.0,
    "monto_iva": 184300.0,
    "monto_total": 1154300.0,
    "fecha": "2026-03-18",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "29",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 27,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3",
    "monto": 1402492.0,
    "monto_iva": 266473.48,
    "monto_total": 1668965.48,
    "fecha": "2026-03-30",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "30",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 28,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS CUADRATURA 13/3 (2)",
    "monto": 1402492.0,
    "monto_iva": 266473.48,
    "monto_total": 1668965.48,
    "fecha": "2026-03-30",
    "notas": "REPUESTOS VENDIDOS A LCTECH",
    "rutContraparte": "77000332-6",
    "razonSocial": "LCTECH",
    "nFactura": "31",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 29,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "EJE DIRECCION",
    "monto": 425500.0,
    "monto_iva": 80845.0,
    "monto_total": 506345.0,
    "fecha": "2026-03-31",
    "notas": "REPUESTOS PARA REACH R40TT",
    "rutContraparte": "77388809-4",
    "razonSocial": "MAX GREDIG SER. MANT EIRL",
    "nFactura": "32",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 30,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "CHAVETA",
    "monto": 12000.0,
    "monto_iva": 2280.0,
    "monto_total": 14280.0,
    "fecha": "2026-03-31",
    "notas": "REPUESTOS PARA REACH R40TT",
    "rutContraparte": "77388809-4",
    "razonSocial": "MAX GREDIG SER. MANT EIRL",
    "nFactura": "32",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 31,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS VARIOS",
    "monto": 267082.0,
    "monto_iva": 50745.58,
    "monto_total": 317827.58,
    "fecha": "2026-04-10",
    "notas": "CUADRATURA 10/4",
    "rutContraparte": "78398053-3",
    "razonSocial": "TITANMAQ SPA",
    "nFactura": "33",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 32,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "CONVERTOR JUNGHEINRICH",
    "monto": 800000.0,
    "monto_iva": 152000.0,
    "monto_total": 952000.0,
    "fecha": "2026-04-14",
    "notas": "PAGADO",
    "rutContraparte": "77.580.626-5",
    "razonSocial": "KMT CHILE LIMITADA",
    "nFactura": "34",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 33,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "RUEDAS DE CARGA REACH + RODAMIENTOS",
    "monto": 445380.0,
    "monto_iva": 84622.2,
    "monto_total": 530002.2,
    "fecha": "2026-04-16",
    "notas": "PAGADO",
    "rutContraparte": "77388809-4",
    "razonSocial": "MAX GREDIG SER. MANT EIRL",
    "nFactura": "35",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 34,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "ESLABONES DE CADENA",
    "monto": 617000.0,
    "monto_iva": 117230.0,
    "monto_total": 734230.0,
    "fecha": "2026-04-20",
    "notas": "cotizacion 192-26",
    "rutContraparte": "96792430-K",
    "razonSocial": "SODIMAC",
    "nFactura": "36",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 35,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "BOMBA DE LEVANTE",
    "monto": 2500000.0,
    "monto_iva": 475000.0,
    "monto_total": 2975000.0,
    "fecha": "2026-04-20",
    "notas": "cotizacion 198-26",
    "rutContraparte": "96792430-K",
    "razonSocial": "SODIMAC",
    "nFactura": "38",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 36,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS VARIOS (1)",
    "monto": 1630058.0,
    "monto_iva": 309711.02,
    "monto_total": 1939769.02,
    "fecha": "2026-05-07",
    "notas": "CUADRATURA 03-05",
    "rutContraparte": "78398053-3",
    "razonSocial": "TITANMAQ SPA",
    "nFactura": "39",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 37,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS VARIOS (2)",
    "monto": 1630058.0,
    "monto_iva": 309711.02,
    "monto_total": 1939769.02,
    "fecha": "2026-05-07",
    "notas": "CUADRATURA 03-05",
    "rutContraparte": "78398053-3",
    "razonSocial": "TITANMAQ SPA",
    "nFactura": "40",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 38,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS VARIOS (3)",
    "monto": 1630058.0,
    "monto_iva": 309711.02,
    "monto_total": 1939769.02,
    "fecha": "2026-05-07",
    "notas": "CUADRATURA 03-05",
    "rutContraparte": "78398053-3",
    "razonSocial": "TITANMAQ SPA",
    "nFactura": "41",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 39,
    "tipo": "venta",
    "subTipo": "facturada",
    "categoria": "Ventas de productos",
    "descripcion": "REPUESTOS VARIOS (4)",
    "monto": 1630058.0,
    "monto_iva": 309711.02,
    "monto_total": 1939769.02,
    "fecha": "2026-05-07",
    "notas": "CUADRATURA 03-05",
    "rutContraparte": "78398053-3",
    "razonSocial": "TITANMAQ SPA",
    "nFactura": "42",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 40,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FUSIBLE 300A, 24V",
    "monto": 11200.0,
    "monto_iva": 2128.0,
    "monto_total": 13328.0,
    "fecha": "2025-08-07",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "7916040029",
    "clienteFinal": "RECURSOS PORTUARIOS Y ESTIBAS LTDA (AGUNSA)/SN BDO",
    "tipoDoc": "SF"
  },
  {
    "id": 41,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "JOYSTICK  HAULOTTE",
    "monto": 221060.0,
    "monto_iva": 42001.4,
    "monto_total": 263061.4,
    "fecha": "2025-08-08",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "2901015000",
    "clienteFinal": "SODIMAC QUILLOTA",
    "tipoDoc": "SF"
  },
  {
    "id": 42,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "INDICADOR DE ACEITE, TRASPALETA 8400",
    "monto": 48000.0,
    "monto_iva": 9120.0,
    "monto_total": 57120.0,
    "fecha": "2025-08-12",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "828-009-885/001",
    "clienteFinal": "SODIMAC MAIPÚ",
    "tipoDoc": "SF"
  },
  {
    "id": 43,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CHAPA ELEVADOR DE TIJERA JLG + LLAVE",
    "monto": 52000.0,
    "monto_iva": 9880.0,
    "monto_total": 61880.0,
    "fecha": "2025-08-13",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "JL4360469",
    "clienteFinal": "SODIMAC MAIPÚ",
    "tipoDoc": "SF"
  },
  {
    "id": 44,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CHAPA 3P HAULOTTE",
    "monto": 31000.0,
    "monto_iva": 5890.0,
    "monto_total": 36890.0,
    "fecha": "2025-08-14",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "L235B",
    "clienteFinal": "SODIMAC PARQUE ARAUCO",
    "tipoDoc": "SF"
  },
  {
    "id": 45,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RODAMIENTOS 6206-2RSC3 BBC",
    "monto": 18340.0,
    "monto_iva": 3484.6,
    "monto_total": 21824.6,
    "fecha": "2025-08-14",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC PARQUE ARAUCO",
    "tipoDoc": "SF"
  },
  {
    "id": 46,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RODAMIENTOS 6305-2RSC3 BBC",
    "monto": 78400.0,
    "monto_iva": 14896.0,
    "monto_total": 93296.0,
    "fecha": "2025-08-14",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC PARQUE ARAUCO",
    "tipoDoc": "SF"
  },
  {
    "id": 47,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RETEN JLG",
    "monto": 112000.0,
    "monto_iva": 21280.0,
    "monto_total": 133280.0,
    "fecha": "2025-08-18",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "70001739",
    "clienteFinal": "SODIMAC MAIPÚ",
    "tipoDoc": "SF"
  },
  {
    "id": 48,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "TOOGLE SWITCH",
    "monto": 36640.0,
    "monto_iva": 6961.6,
    "monto_total": 43601.6,
    "fecha": "2025-08-18",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "4360539",
    "clienteFinal": "SODIMAC MAIPÚ",
    "tipoDoc": "SF"
  },
  {
    "id": 49,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CHAPA ITALIANA",
    "monto": 46774.0,
    "monto_iva": 8887.06,
    "monto_total": 55661.06,
    "fecha": "2025-08-19",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC PARQUE ARAUCO",
    "tipoDoc": "SF"
  },
  {
    "id": 50,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CONECTOR JOYSTICK",
    "monto": 58077.0,
    "monto_iva": 11034.630000000001,
    "monto_total": 69111.63,
    "fecha": "2025-08-19",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "4461016",
    "clienteFinal": "AYF",
    "tipoDoc": "SF"
  },
  {
    "id": 51,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CONJUNTO DE CONECTOR JLG",
    "monto": 64600.0,
    "monto_iva": 12274.0,
    "monto_total": 76874.0,
    "fecha": "2025-08-19",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "JL4460754",
    "clienteFinal": "AYF",
    "tipoDoc": "SF"
  },
  {
    "id": 52,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "SWITCH FRENO",
    "monto": 15120.0,
    "monto_iva": 2872.8,
    "monto_total": 17992.8,
    "fecha": "2025-08-19",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "RA1-150-355",
    "clienteFinal": "SODIMAC TOBALABA",
    "tipoDoc": "SF"
  },
  {
    "id": 53,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "TÁPON DE CONECTOR, TERMINAL SOCKET 16-20 GA",
    "monto": 11600.0,
    "monto_iva": 2204.0,
    "monto_total": 13804.0,
    "fecha": "2025-08-19",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "4460465",
    "clienteFinal": "AYF",
    "tipoDoc": "SF"
  },
  {
    "id": 54,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CHAPA ITALIANA",
    "monto": 46774.0,
    "monto_iva": 8887.06,
    "monto_total": 55661.06,
    "fecha": "2025-08-20",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC PUERTO MONTT",
    "tipoDoc": "SF"
  },
  {
    "id": 55,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "BALIZA IMBEST CH01554FL81DAM",
    "monto": 14000.0,
    "monto_iva": 2660.0,
    "monto_total": 16660.0,
    "fecha": "2025-08-22",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "MUNDO TRANSFER",
    "tipoDoc": "SF"
  },
  {
    "id": 56,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "BLUESPOT LED GRUA 20W 12-80 LASER LED",
    "monto": 21750.0,
    "monto_iva": 4132.5,
    "monto_total": 25882.5,
    "fecha": "2025-08-22",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "MUNDO TRANSFER",
    "tipoDoc": "SF"
  },
  {
    "id": 57,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "ENCHUFE ANDERSON 160A ROJO",
    "monto": 16300.0,
    "monto_iva": 3097.0,
    "monto_total": 19397.0,
    "fecha": "2025-08-22",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "RECURSOS PORTUARIOS Y ESTIBAS LTDA (AGUNSA)/SN BDO",
    "tipoDoc": "SF"
  },
  {
    "id": 58,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CANDADO O SEGURO CADENA.",
    "monto": 184000.0,
    "monto_iva": 34960.0,
    "monto_total": 218960.0,
    "fecha": "2025-08-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC CD",
    "tipoDoc": "SF"
  },
  {
    "id": 59,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CANDADO O SEGURO CADENA.",
    "monto": 276000.0,
    "monto_iva": 52440.0,
    "monto_total": 328440.0,
    "fecha": "2025-08-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC CD",
    "tipoDoc": "SF"
  },
  {
    "id": 60,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FILTRO ACEITE",
    "monto": 11882.0,
    "monto_iva": 2257.58,
    "monto_total": 14139.58,
    "fecha": "2025-08-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "LF3349",
    "clienteFinal": "SODIMAC LO RUIZ",
    "tipoDoc": "SF"
  },
  {
    "id": 61,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FILTRO AIRE PRIMARIO",
    "monto": 44596.0,
    "monto_iva": 8473.24,
    "monto_total": 53069.24,
    "fecha": "2025-08-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "0119372138N",
    "clienteFinal": "SODIMAC LO RUIZ",
    "tipoDoc": "SF"
  },
  {
    "id": 62,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FILTRO AIRE SECUNDARIO",
    "monto": 34212.0,
    "monto_iva": 6500.28,
    "monto_total": 40712.28,
    "fecha": "2025-08-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "0119372142N",
    "clienteFinal": "SODIMAC LO RUIZ",
    "tipoDoc": "SF"
  },
  {
    "id": 63,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "ENCHUFE ANDERSON 175A GRIS",
    "monto": 16300.0,
    "monto_iva": 3097.0,
    "monto_total": 19397.0,
    "fecha": "2025-08-28",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC CERRILLOS",
    "tipoDoc": "SF"
  },
  {
    "id": 64,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "ENCHUFE ANDERSON 350A GRIS",
    "monto": 58500.0,
    "monto_iva": 11115.0,
    "monto_total": 69615.0,
    "fecha": "2025-09-09",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "AND-350-G",
    "clienteFinal": "COMERCIALIZADORA SELECTA",
    "tipoDoc": "SF"
  },
  {
    "id": 65,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "BUTTON . NO FUCTION",
    "monto": 59500.0,
    "monto_iva": 11305.0,
    "monto_total": 70805.0,
    "fecha": "2025-09-10",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "1027272",
    "clienteFinal": "SODIMAC PUERTO MONTT",
    "tipoDoc": "SF"
  },
  {
    "id": 66,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CODIFICADOR ENCODER 6206V",
    "monto": 152000.0,
    "monto_iva": 28880.0,
    "monto_total": 180880.0,
    "fecha": "2025-09-10",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "EMPRESA MAX GREDIG SERVICIOS DE MANTENCIÓN E INSTALACIÓN",
    "nFactura": "S/F",
    "pn": "146080-007",
    "clienteFinal": "MAX GREDING",
    "tipoDoc": "SF"
  },
  {
    "id": 67,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CONTACTOR 24V, 300A",
    "monto": 300000.0,
    "monto_iva": 57000.0,
    "monto_total": 357000.0,
    "fecha": "2025-09-10",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "EMPRESA MAX GREDIG SERVICIOS DE MANTENCIÓN E INSTALACIÓN",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "MAX GREDING",
    "tipoDoc": "SF"
  },
  {
    "id": 68,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "SOLENOIDE 24V / 150A",
    "monto": 22000.0,
    "monto_iva": 4180.0,
    "monto_total": 26180.0,
    "fecha": "2025-09-15",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "SOL-24V-CC",
    "clienteFinal": "SODIMAC CERRILLOS",
    "tipoDoc": "SF"
  },
  {
    "id": 69,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RODAMIENTOS 6305-2RSC3 BBC",
    "monto": 78504.0,
    "monto_iva": 14915.76,
    "monto_total": 93419.76,
    "fecha": "2025-09-16",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "6305-2RSC3",
    "clienteFinal": "SODIMAC COYHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 70,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RUEDAS DE CARGA PE",
    "monto": 316448.0,
    "monto_iva": 60125.12,
    "monto_total": 376573.12,
    "fecha": "2025-09-16",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "RC-RAY-R40TT",
    "clienteFinal": "SODIMAC COYHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 71,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RUEDA DE TRACCIÓN",
    "monto": 234000.0,
    "monto_iva": 44460.0,
    "monto_total": 278460.0,
    "fecha": "2025-09-24",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "RT-EGV14",
    "clienteFinal": "RECURSOS PORTUARIOS Y ESTIBAS LTDA (AGUNSA)/SN BDO",
    "tipoDoc": "SF"
  },
  {
    "id": 72,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "SWITCH. DE FRENO GRUA HORQUILLA",
    "monto": 109681.0,
    "monto_iva": 20839.39,
    "monto_total": 130520.39,
    "fecha": "2025-09-26",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC LO RUIZ",
    "tipoDoc": "SF"
  },
  {
    "id": 73,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FILTRO HIDRAULICO HF6510",
    "monto": 15400.0,
    "monto_iva": 2926.0,
    "monto_total": 18326.0,
    "fecha": "2025-09-29",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "HF6510",
    "clienteFinal": "SODIMAC QUILICURA",
    "tipoDoc": "SF"
  },
  {
    "id": 74,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "KIT DE CONTACTOR RA1105129111",
    "monto": 304200.0,
    "monto_iva": 57798.0,
    "monto_total": 361998.0,
    "fecha": "2025-09-29",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "RA1105129111",
    "clienteFinal": "SODIMAC QUILICURA",
    "tipoDoc": "SF"
  },
  {
    "id": 75,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "BUJIAS (JUEGO)",
    "monto": 15716.0,
    "monto_iva": 2986.04,
    "monto_total": 18702.04,
    "fecha": "2025-09-30",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "EF27-J01",
    "clienteFinal": "INTERBAKE",
    "tipoDoc": "SF"
  },
  {
    "id": 76,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CONECTOR MACHO Y HEMBRA 4 VÍAS",
    "monto": 6500.0,
    "monto_iva": 1235.0,
    "monto_total": 7735.0,
    "fecha": "2025-09-30",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "D651-4",
    "clienteFinal": "SODIMAC QUILICURA",
    "tipoDoc": "SF"
  },
  {
    "id": 77,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "EMPAQUETADURA CULATA METALICA",
    "monto": 37857.0,
    "monto_iva": 7192.83,
    "monto_total": 45049.83,
    "fecha": "2025-09-30",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "EF02-J10",
    "clienteFinal": "INTERBAKE",
    "tipoDoc": "SF"
  },
  {
    "id": 78,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "EMPAQUETADURA MULTIPLE Y ESCAPE",
    "monto": 12290.0,
    "monto_iva": 2335.1,
    "monto_total": 14625.1,
    "fecha": "2025-09-30",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "EF10-J01",
    "clienteFinal": "INTERBAKE",
    "tipoDoc": "SF"
  },
  {
    "id": 79,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "TAPA DEPOSITO EQUIPOS RAYMOND",
    "monto": 132785.0,
    "monto_iva": 25229.15,
    "monto_total": 158014.15,
    "fecha": "2025-09-30",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "850525",
    "clienteFinal": "SODIMAC QUILICURA",
    "tipoDoc": "SF"
  },
  {
    "id": 80,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CORREA ANTIESTATICA",
    "monto": 14895.0,
    "monto_iva": 2830.05,
    "monto_total": 17725.05,
    "fecha": "2025-10-01",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "4360539",
    "clienteFinal": "SODIMAC ESTACION CENTRAL",
    "tipoDoc": "SF"
  },
  {
    "id": 81,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "JOYSTICK JLG",
    "monto": 141000.0,
    "monto_iva": 26790.0,
    "monto_total": 167790.0,
    "fecha": "2025-10-01",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "1001134438",
    "clienteFinal": "SODIMAC ESTACION CENTRAL",
    "tipoDoc": "SF"
  },
  {
    "id": 82,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "SOLENOIDE 24V / 150A",
    "monto": 22000.0,
    "monto_iva": 4180.0,
    "monto_total": 26180.0,
    "fecha": "2025-10-01",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "SOL-24V-CC",
    "clienteFinal": "INTERBAKE",
    "tipoDoc": "SF"
  },
  {
    "id": 83,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "TOOGLE SWITCH",
    "monto": 36640.0,
    "monto_iva": 6961.6,
    "monto_total": 43601.6,
    "fecha": "2025-10-01",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "4360539",
    "clienteFinal": "SODIMAC ESTACION CENTRAL",
    "tipoDoc": "SF"
  },
  {
    "id": 84,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Baliza Ambar 110V",
    "monto": 14000.0,
    "monto_iva": 2660.0,
    "monto_total": 16660.0,
    "fecha": "2025-10-06",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "INM-QPM6650976",
    "clienteFinal": "SODIMAC COHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 85,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Joystick  (reacondicionado)",
    "monto": 250000.0,
    "monto_iva": 47500.0,
    "monto_total": 297500.0,
    "fecha": "2025-10-06",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "1014652-102",
    "clienteFinal": "SODIMAC COHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 86,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Pasador Rueda Caster",
    "monto": 45000.0,
    "monto_iva": 8550.0,
    "monto_total": 53550.0,
    "fecha": "2025-10-06",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "828-006-728",
    "clienteFinal": "SODIMAC COHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 87,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Perilla Dirección",
    "monto": 42250.0,
    "monto_iva": 8027.5,
    "monto_total": 50277.5,
    "fecha": "2025-10-06",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "828-005-714",
    "clienteFinal": "SODIMAC COHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 88,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Seguro Pasador x 2",
    "monto": 6400.0,
    "monto_iva": 1216.0,
    "monto_total": 7616.0,
    "fecha": "2025-10-06",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "810-022",
    "clienteFinal": "SODIMAC COHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 89,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Tapa perilla",
    "monto": 5100.0,
    "monto_iva": 969.0,
    "monto_total": 6069.0,
    "fecha": "2025-10-06",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "861-312",
    "clienteFinal": "SODIMAC COHAIQUE",
    "tipoDoc": "SF"
  },
  {
    "id": 90,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RODAMIENTO 6305 (RUEDA CARGA)",
    "monto": 78504.0,
    "monto_iva": 14915.76,
    "monto_total": 93419.76,
    "fecha": "2025-10-11",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC QUINTA VERGARA",
    "tipoDoc": "SF"
  },
  {
    "id": 91,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Rueda Carga Raymond",
    "monto": 301500.0,
    "monto_iva": 57285.0,
    "monto_total": 358785.0,
    "fecha": "2025-10-11",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC QUINTA VERGARA",
    "tipoDoc": "SF"
  },
  {
    "id": 92,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RUEDA CASTER EQUIPO BT",
    "monto": 290600.0,
    "monto_iva": 55214.0,
    "monto_total": 345814.0,
    "fecha": "2025-10-15",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC QUILIN",
    "tipoDoc": "SF"
  },
  {
    "id": 93,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Rueda Caster Traspaleta Raymond Stand (inc. Rodamiento 6204 x 4und)",
    "monto": 160000.0,
    "monto_iva": 30400.0,
    "monto_total": 190400.0,
    "fecha": "2025-10-15",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "INTERBAKE",
    "tipoDoc": "SF"
  },
  {
    "id": 94,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "Rueda TRACCIÓN RECAUCHADA",
    "monto": 300000.0,
    "monto_iva": 57000.0,
    "monto_total": 357000.0,
    "fecha": "2025-10-15",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "INTERBAKE",
    "tipoDoc": "SF"
  },
  {
    "id": 95,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FILTRO DE ACEITE",
    "monto": 8400.0,
    "monto_iva": 1596.0,
    "monto_total": 9996.0,
    "fecha": "2025-10-16",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "MOLINO",
    "tipoDoc": "SF"
  },
  {
    "id": 96,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FILTRO DE AIRE",
    "monto": 47800.0,
    "monto_iva": 9082.0,
    "monto_total": 56882.0,
    "fecha": "2025-10-16",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "MOLINO",
    "tipoDoc": "SF"
  },
  {
    "id": 97,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "BOCINA 48V",
    "monto": 53200.0,
    "monto_iva": 10108.0,
    "monto_total": 63308.0,
    "fecha": "2025-10-17",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "INTERBAKE",
    "tipoDoc": "SF"
  },
  {
    "id": 98,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "ENCHUFE SMH MACHO 160A",
    "monto": 36050.0,
    "monto_iva": 6849.5,
    "monto_total": 42899.5,
    "fecha": "2025-10-20",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "MUNDO TRANSFER",
    "tipoDoc": "SF"
  },
  {
    "id": 99,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RETEN JLG",
    "monto": 112000.0,
    "monto_iva": 21280.0,
    "monto_total": 133280.0,
    "fecha": "2025-10-20",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "70001739",
    "clienteFinal": "SODIMAC ESTACION CENTRAL",
    "tipoDoc": "SF"
  },
  {
    "id": 100,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "RUEDAS EQUIPO JLG",
    "monto": 363400.0,
    "monto_iva": 69046.0,
    "monto_total": 432446.0,
    "fecha": "2025-10-20",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC ESTACION CENTRAL",
    "tipoDoc": "SF"
  },
  {
    "id": 101,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CORREA ANTIESTATICA",
    "monto": 14895.0,
    "monto_iva": 2830.05,
    "monto_total": 17725.05,
    "fecha": "2025-10-21",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC MAIPÚ",
    "tipoDoc": "SF"
  },
  {
    "id": 102,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "BOMBA HIDRAULICA",
    "monto": 899000.0,
    "monto_iva": 170810.0,
    "monto_total": 1069810.0,
    "fecha": "2025-10-23",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC PARQUE ARAUCO",
    "tipoDoc": "SF"
  },
  {
    "id": 103,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "ORINGS RUEDA JLG",
    "monto": 2100.0,
    "monto_iva": 399.0,
    "monto_total": 2499.0,
    "fecha": "2025-10-23",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "70000191",
    "clienteFinal": "SODIMAC ESTACION CENTRAL",
    "tipoDoc": "SF"
  },
  {
    "id": 104,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "SEGURO DE CADENA",
    "monto": 345000.0,
    "monto_iva": 65550.0,
    "monto_total": 410550.0,
    "fecha": "2025-10-23",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "0-200.0215.742",
    "clienteFinal": "SODIMAC CD",
    "tipoDoc": "SF"
  },
  {
    "id": 105,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "ACEITE 15W40 7 LTS MANNOL",
    "monto": 78000.0,
    "monto_iva": 14820.0,
    "monto_total": 92820.0,
    "fecha": "2025-10-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC",
    "tipoDoc": "SF"
  },
  {
    "id": 106,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "CORREA ALTERNADOR",
    "monto": 21750.0,
    "monto_iva": 4132.5,
    "monto_total": 25882.5,
    "fecha": "2025-10-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC",
    "tipoDoc": "SF"
  },
  {
    "id": 107,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "FILTRO ACEITE",
    "monto": 12456.0,
    "monto_iva": 2366.64,
    "monto_total": 14822.64,
    "fecha": "2025-10-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC",
    "tipoDoc": "SF"
  },
  {
    "id": 108,
    "tipo": "venta",
    "subTipo": "sin_factura",
    "categoria": "Ventas de productos",
    "descripcion": "PASTILLA FRENOS (DELANTERA - TRASERA)",
    "monto": 65746.0,
    "monto_iva": 12491.74,
    "monto_total": 78237.74,
    "fecha": "2025-10-27",
    "notas": "Registro interno — empresa no habilitada SII",
    "rutContraparte": "",
    "razonSocial": "LCTECH SPA",
    "nFactura": "S/F",
    "pn": "",
    "clienteFinal": "SODIMAC",
    "tipoDoc": "SF"
  },
  {
    "id": 109,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "JOYSTICK HAULOTTE  COMPACT 10",
    "monto": 172477.0,
    "monto_iva": 30001.0,
    "monto_total": 205247.63,
    "fecha": "2025-08-08",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RENTAL PATAGONIA",
    "nFactura": "14597",
    "pn": "2901015000",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 110,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FUSIBLE 300A, 32V",
    "monto": 24978.0,
    "monto_iva": 3988.0,
    "monto_total": 29723.82,
    "fecha": "2025-08-13",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ENERKIT",
    "nFactura": "20951",
    "pn": "7916040029",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 111,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ENCHUFE ANDERSON 175A  4 A 1/0 AWG GRIS",
    "monto": 40715.0,
    "monto_iva": 7903.0,
    "monto_total": 48450.85,
    "fecha": "2025-08-13",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "SOLIOT SPA",
    "nFactura": "1058",
    "pn": "590-724",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 112,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ENCHUFE ANDERSON 175A  4 A 1/0 AWG GRIS",
    "monto": 41597.0,
    "monto_iva": 7903.0,
    "monto_total": 0.0,
    "fecha": "2025-08-13",
    "notas": "REPETIDA",
    "rutContraparte": "",
    "razonSocial": "SOLIOT SPA",
    "nFactura": "1059",
    "pn": "590-724",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 113,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "(CHAPA) SELECTOR CNC BG33 C/LLAVE 1-0-2 NA/NC METAL",
    "monto": 5252.0,
    "monto_iva": 997.88,
    "monto_total": 6249.88,
    "fecha": "2025-08-14",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ELECTRONICA HOBBY",
    "nFactura": "137153",
    "pn": "L235B",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 114,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS 6305-2RSC3 BBC",
    "monto": 22400.0,
    "monto_iva": 4256.0,
    "monto_total": 26656.0,
    "fecha": "2025-08-14",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3594981",
    "pn": "6305-2RSC3",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 115,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS 6206-2RSC3 BBC",
    "monto": 5240.0,
    "monto_iva": 995.6,
    "monto_total": 6235.599999999999,
    "fecha": "2025-08-14",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3594981",
    "pn": "6206-2RSC3",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 116,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RETEN LABIO PRINCIPAL RUEDA",
    "monto": 301940.33613445377,
    "monto_iva": 57368.663865546216,
    "monto_total": 359308.99999999994,
    "fecha": "2025-08-18",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "22282",
    "pn": "70001739",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 117,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "IMPUESTO JOYSTICK",
    "monto": 50542.0,
    "monto_iva": 0.0,
    "monto_total": 0.0,
    "fecha": "2025-08-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "1077409",
    "pn": "-",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 118,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "NO FACTURABLE",
    "monto": 100579.0,
    "monto_iva": 0.0,
    "monto_total": 0.0,
    "fecha": "2025-08-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "1077409",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 119,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CHAPA ITALIANA",
    "monto": 114000.0,
    "monto_iva": 21660.0,
    "monto_total": 135660.0,
    "fecha": "2025-08-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "VER TRUCK",
    "nFactura": "1576",
    "pn": "CHAPA-ITALIANA",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 120,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE",
    "monto": 7613.0,
    "monto_iva": 1446.47,
    "monto_total": 9059.47,
    "fecha": "2025-08-26",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "CENTRAL FILTROS",
    "nFactura": "237464",
    "pn": "LF3349",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 121,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE PRIMARIO",
    "monto": 31854.0,
    "monto_iva": 6052.26,
    "monto_total": 37906.259999999995,
    "fecha": "2025-08-26",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SALFA",
    "nFactura": "4995896",
    "pn": "0119372138N",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 122,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SEGURO CADENA 80H RS80-H-1-MWJL",
    "monto": 27132.0,
    "monto_iva": 5155.08,
    "monto_total": 32287.079999999998,
    "fecha": "2025-08-27",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DUCASSE",
    "nFactura": "1747154",
    "pn": "121501316700",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 123,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SEGURO CADENA 80H RS80-H-1-FWJL",
    "monto": 18366.0,
    "monto_iva": 3489.54,
    "monto_total": 21869.0,
    "fecha": "2025-08-27",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DUCASSE",
    "nFactura": "1747154",
    "pn": "121501318500",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 124,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE SECUNDARIO",
    "monto": 24437.0,
    "monto_iva": 4643.03,
    "monto_total": 29080.03,
    "fecha": "2025-08-27",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SALFA",
    "nFactura": "4995896",
    "pn": "0119372142N",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 125,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SOLENOIDE 24V /",
    "monto": 28370.0,
    "monto_iva": 0.0,
    "monto_total": 33760.0,
    "fecha": "2025-09-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MAS POTENCIA",
    "nFactura": "1499",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 126,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS 6305-2RSC3 BBC",
    "monto": 22400.0,
    "monto_iva": 4256.0,
    "monto_total": 26656.0,
    "fecha": "2025-09-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3601334",
    "pn": "6305-2RSC3",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 127,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SWITCH. DE FRENO GRUA HORQUILLA",
    "monto": 83092.0,
    "monto_iva": 15787.48,
    "monto_total": 98879.48,
    "fecha": "2025-09-26",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "CLEMSA S.A",
    "nFactura": "100641",
    "pn": "81FQ-47120",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 128,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "EMPAQUETADURA CULATA METALICA",
    "monto": 25238.0,
    "monto_iva": 4795.22,
    "monto_total": 30033.219999999998,
    "fecha": "2025-09-30",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "4568",
    "pn": "EF02-J10",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 129,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "EMPAQUETADURA MULTIPLE Y ESCAPE",
    "monto": 8193.0,
    "monto_iva": 1556.67,
    "monto_total": 9749.67,
    "fecha": "2025-09-30",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "4568",
    "pn": "EF10-J01",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 130,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BUJIAS",
    "monto": 10477.0,
    "monto_iva": 1990.63,
    "monto_total": 12467.63,
    "fecha": "2025-09-30",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "4568",
    "pn": "EF27-J01",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 131,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO HIDRAULICO",
    "monto": 8570.0,
    "monto_iva": 1628.3,
    "monto_total": 10198.3,
    "fecha": "2025-09-30",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MINING PARTS SPA",
    "nFactura": "15937",
    "pn": "HF6510",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 132,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CHAPAS PARA ORDENADORES DE PASILLOS",
    "monto": 20453.0,
    "monto_iva": 3886.07,
    "monto_total": 24339.07,
    "fecha": "2025-10-09",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "WYSS Y TOLEDO LTDA",
    "nFactura": "5759",
    "pn": "1350A",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 133,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS 6205 2RSC3 BBC",
    "monto": 16880.0,
    "monto_iva": 3207.2,
    "monto_total": 20087.2,
    "fecha": "2025-10-10",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3605725",
    "pn": "A0006205U203B",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 134,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6206-2RSC3 BBC",
    "monto": 15720.0,
    "monto_iva": 2986.8,
    "monto_total": 18706.8,
    "fecha": "2025-10-10",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3605725",
    "pn": "A0006206U203B",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 135,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6305-2RSC3 BBC",
    "monto": 22400.0,
    "monto_iva": 4256.0,
    "monto_total": 26656.0,
    "fecha": "2025-10-10",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3605725",
    "pn": "A0006305U203B",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 136,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER 125/050/095/5/20 (BT LPE200)",
    "monto": 49414.0,
    "monto_iva": 9388.66,
    "monto_total": 58802.659999999996,
    "fecha": "2025-10-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "18772",
    "pn": "5710025320",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 137,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA MOTRIZ 343/114/276/090 F8 AVELLANADO (JUNGHENRICH)",
    "monto": 386734.0,
    "monto_iva": 73479.46,
    "monto_total": 0.0,
    "fecha": "2025-10-13",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "18771",
    "pn": "5710411200",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 138,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA 285/100/245/6/40 JUNGHENRICH",
    "monto": 875230.2,
    "monto_iva": 166293.73799999998,
    "monto_total": 0.0,
    "fecha": "2025-10-13",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "18771",
    "pn": "5710254710",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 139,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA LATERAL RAYMOND",
    "monto": 85790.0,
    "monto_iva": 16300.1,
    "monto_total": 102090.09999999999,
    "fecha": "2025-10-14",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ARRIMAQ",
    "nFactura": "260673",
    "pn": "67104107",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 140,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER 125/050/095/5/20 (BT LPE200)",
    "monto": 148242.0,
    "monto_iva": 28165.98,
    "monto_total": 176407.97999999998,
    "fecha": "2025-10-14",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "18790",
    "pn": "5710025320",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 141,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ARRIENDO EQUIPO",
    "monto": 706819.0,
    "monto_iva": 134295.61000000002,
    "monto_total": 0.0,
    "fecha": "2025-10-14",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 142,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOCINA 48V",
    "monto": 35708.0,
    "monto_iva": 6784.52,
    "monto_total": 42492.52,
    "fecha": "2025-10-16",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "4913",
    "pn": "LC06-J03",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 143,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6204 2RSC",
    "monto": 12432.0,
    "monto_iva": 2362.08,
    "monto_total": 14794.08,
    "fecha": "2025-10-16",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "657016",
    "pn": "6204-2RSC3",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 144,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE 154051765 A029",
    "monto": 4276.0,
    "monto_iva": 812.44,
    "monto_total": 5088.44,
    "fecha": "2025-10-17",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "71021",
    "pn": "86849",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 145,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE B033",
    "monto": 27300.0,
    "monto_iva": 5187.0,
    "monto_total": 32487.0,
    "fecha": "2025-10-17",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "71021",
    "pn": "105503",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 146,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS JLG 1930ES",
    "monto": 263960.0,
    "monto_iva": 50152.4,
    "monto_total": 314112.39999999997,
    "fecha": "2025-10-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RENTAL PATAGONIA",
    "nFactura": "15168",
    "pn": "2915012",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 147,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SEGURO CADENA 80H RS80-H-1-FWJL",
    "monto": 113625.0,
    "monto_iva": 21588.75,
    "monto_total": 135213.75,
    "fecha": "2025-10-23",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DUCASSE",
    "nFactura": "1764407",
    "pn": "121501318500",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 148,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOMBA HIDRAULICA",
    "monto": 580000.0,
    "monto_iva": 110200.0,
    "monto_total": 690200.0,
    "fecha": "2025-10-23",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "HAULOTTE CHILE",
    "nFactura": "7319",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 149,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ORINGS RUEDA JLG",
    "monto": 3975.0,
    "monto_iva": 755.25,
    "monto_total": 4730.25,
    "fecha": "2025-10-23",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "22696",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 150,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "HOSTING INMALUCA",
    "monto": 54800.0,
    "monto_iva": 10412.0,
    "monto_total": 65212.0,
    "fecha": "2025-10-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ECOHOSTING INTERNET LIMITADA",
    "nFactura": "2859",
    "pn": "-",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 151,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PASTILLA FRENOS (DELANTERA - TRASERA)",
    "monto": 31780.0,
    "monto_iva": 6038.0,
    "monto_total": 37818.0,
    "fecha": "2025-10-25",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "IMPORTADORA ITAL FRENOS SPA",
    "nFactura": "2396283",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 152,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO ACEITE",
    "monto": 5042.0,
    "monto_iva": 957.98,
    "monto_total": 6000.0,
    "fecha": "2025-10-25",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RCL REPUESTOS LTDA",
    "nFactura": "6177",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 153,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CORREA ALTERNADOR",
    "monto": 1092.0,
    "monto_iva": 207.48,
    "monto_total": 13000.0,
    "fecha": "2025-10-25",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RCL REPUESTOS LTDA",
    "nFactura": "6177",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 154,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ACEITE 15W40 7 LTS MANNOL",
    "monto": 33605.04201680672,
    "monto_iva": 6384.957983193277,
    "monto_total": 39990.0,
    "fecha": "2025-10-27",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "INVERSIONES RODRIGUEZ SPA",
    "nFactura": "742",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 155,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "REPUESTOS VARIOS",
    "monto": 1794770.0,
    "monto_iva": 341006.3,
    "monto_total": 0.0,
    "fecha": "2025-10-28",
    "notas": "contabilizado en hoja de IVA",
    "rutContraparte": "",
    "razonSocial": "LCTECH",
    "nFactura": "2498",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 156,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO HIDRAULICO",
    "monto": 18201.68,
    "monto_iva": 3458.3192,
    "monto_total": 21659.9992,
    "fecha": "2025-10-30",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MINING PARTS SPA",
    "nFactura": "16398",
    "pn": "HF6510",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 157,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RETEN LABIO PRINCIPAL RUEDA",
    "monto": 295224.0,
    "monto_iva": 56092.56,
    "monto_total": 351316.56,
    "fecha": "2025-11-04",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "22821",
    "pn": "70001739",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 158,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ORINGS RUEDA JLG",
    "monto": 5260.0,
    "monto_iva": 999.4,
    "monto_total": 6259.4,
    "fecha": "2025-11-04",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "22821",
    "pn": "70000191",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 159,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ORING LADO MOTOR RUEDA JLG",
    "monto": 15380.0,
    "monto_iva": 2922.2,
    "monto_total": 18302.2,
    "fecha": "2025-11-06",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "22833",
    "pn": "7024786",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 160,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA TRANSPALETA RAYMOND 8400",
    "monto": 60000.0,
    "monto_iva": 11400.0,
    "monto_total": 71400.0,
    "fecha": "2025-11-10",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2071",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 161,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA REACH R40TT",
    "monto": 200000.0,
    "monto_iva": 38000.0,
    "monto_total": 238000.0,
    "fecha": "2025-11-10",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2071",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 162,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA MOTRIZ REACH JUNGHEINRICH ETV110",
    "monto": 220000.0,
    "monto_iva": 41800.0,
    "monto_total": 261800.0,
    "fecha": "2025-11-10",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2071",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 163,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ADUANA SENSORES BT",
    "monto": 16008.0,
    "monto_iva": 3041.52,
    "monto_total": 0.0,
    "fecha": "2025-11-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DHL EXPRESS",
    "nFactura": "4602342",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 164,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA CROWN PE4500 82/165/5/25",
    "monto": 184472.0,
    "monto_iva": 35049.68,
    "monto_total": 219521.68,
    "fecha": "2025-11-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "18987",
    "pn": "5715054996",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 165,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PERILLA JUNGHENRICH",
    "monto": 19861.0,
    "monto_iva": 3773.59,
    "monto_total": 23634.59,
    "fecha": "2025-11-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "71648",
    "pn": "51134300",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 166,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RETEN TC 25 40 7",
    "monto": 4867.0,
    "monto_iva": 924.73,
    "monto_total": 5791.73,
    "fecha": "2025-11-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "660291",
    "pn": "25 40 7",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 167,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6206 2RS NSK",
    "monto": 7533.0,
    "monto_iva": 1431.27,
    "monto_total": 8964.27,
    "fecha": "2025-11-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "660291",
    "pn": "6206",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 168,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER CROWN PE4500",
    "monto": 80000.0,
    "monto_iva": 15200.0,
    "monto_total": 95200.0,
    "fecha": "2025-11-17",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2078",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 169,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA CROWN PE4500 82/165/5/25",
    "monto": 184472.0,
    "monto_iva": 35049.68,
    "monto_total": -219521.68,
    "fecha": "2025-11-17",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "NC-1138",
    "pn": "5715054996",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 170,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA CROWN PE4500 S/RODAMIENTO",
    "monto": 127188.0,
    "monto_iva": 24165.72,
    "monto_total": 151353.72,
    "fecha": "2025-11-17",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19017",
    "pn": "5714054950",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 171,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA LINDE",
    "monto": 643144.0,
    "monto_iva": 122197.36,
    "monto_total": 765341.36,
    "fecha": "2025-11-17",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19014",
    "pn": "5710252201",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 172,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO HIDRAULICO HAULOTTE INTERBAKE",
    "monto": 36151.0,
    "monto_iva": 6868.6900000000005,
    "monto_total": 43019.69,
    "fecha": "2025-11-17",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MINING PARTS SPA",
    "nFactura": "16609",
    "pn": "HF6173",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 173,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PIOLA ACELERADOR",
    "monto": 22501.0,
    "monto_iva": 4275.19,
    "monto_total": 26776.19,
    "fecha": "2025-11-18",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "5471",
    "pn": "AD22-J08",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 174,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 5205-2RS",
    "monto": 16000.0,
    "monto_iva": 3040.0,
    "monto_total": 19040.0,
    "fecha": "2025-11-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3613534",
    "pn": "5205-2RS",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 175,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6305-2RS",
    "monto": 18000.0,
    "monto_iva": 3420.0,
    "monto_total": 21420.0,
    "fecha": "2025-11-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3613534",
    "pn": "6305-2RS",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 176,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6205-2RSC3 BBC",
    "monto": 16800.0,
    "monto_iva": 3192.0,
    "monto_total": 19992.0,
    "fecha": "2025-11-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3613534",
    "pn": "6205-2RS",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 177,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LAINA DE AJUSTE 33X20",
    "monto": 7200.0,
    "monto_iva": 1368.0,
    "monto_total": 8568.0,
    "fecha": "2025-11-19",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "194001",
    "pn": "0607-1040",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 178,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LAINA DE AJUSTE 40X25",
    "monto": 9000.0,
    "monto_iva": 1710.0,
    "monto_total": 10710.0,
    "fecha": "2025-11-19",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "194001",
    "pn": "0607-1057",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 179,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LAINA DE AJUSTE 47X30",
    "monto": 9000.0,
    "monto_iva": 1710.0,
    "monto_total": 10710.0,
    "fecha": "2025-11-19",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "194001",
    "pn": "0607-1090",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 180,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA LINDE",
    "monto": 643144.0,
    "monto_iva": 122197.36,
    "monto_total": -765341.36,
    "fecha": "2025-11-21",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "NC-1139",
    "pn": "5710252201",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 181,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS GIRATORIA 200X50",
    "monto": 33960.0,
    "monto_iva": 6452.4,
    "monto_total": 40412.4,
    "fecha": "2025-11-21",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODANNI",
    "nFactura": "121023",
    "pn": "PR29200TPR",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 182,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS FIJAS 150X50",
    "monto": 31020.0,
    "monto_iva": 5893.8,
    "monto_total": 36913.799999999996,
    "fecha": "2025-11-21",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODANNI",
    "nFactura": "121024",
    "pn": "PR29150TPR",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 183,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS RECAUCHADAS",
    "monto": 490000.0,
    "monto_iva": 93100.0,
    "monto_total": 583100.0,
    "fecha": "2025-11-25",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2083",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 184,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS RECAUCHADAS",
    "monto": 490000.0,
    "monto_iva": 93100.0,
    "monto_total": -583100.0,
    "fecha": "2025-11-25",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "54",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 185,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS CARGA LINDE",
    "monto": 320000.0,
    "monto_iva": 60800.0,
    "monto_total": 380800.0,
    "fecha": "2025-11-25",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2084",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 186,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER TRANSPALETA 8400",
    "monto": 70000.0,
    "monto_iva": 13300.0,
    "monto_total": 83300.0,
    "fecha": "2025-11-25",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2084",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 187,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CARGA CROWN  PE4500",
    "monto": 100000.0,
    "monto_iva": 19000.0,
    "monto_total": 119000.0,
    "fecha": "2025-11-25",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2084",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 188,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA LATERAL RAYMOND",
    "monto": 145843.0,
    "monto_iva": 27710.170000000002,
    "monto_total": 173553.17,
    "fecha": "2025-11-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ARRIMAQ",
    "nFactura": "261955",
    "pn": "67104107",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 189,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE 154051765 A029",
    "monto": 4276.0,
    "monto_iva": 812.44,
    "monto_total": 5088.4400000000005,
    "fecha": "2025-11-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "72033",
    "pn": "86849",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 190,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE B033",
    "monto": 27300.0,
    "monto_iva": 5187.0,
    "monto_total": 32487.0,
    "fecha": "2025-11-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "72033",
    "pn": "105503",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 191,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6204 2RSC",
    "monto": 13360.0,
    "monto_iva": 2538.4,
    "monto_total": 15898.4,
    "fecha": "2025-11-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3614936",
    "pn": "6204 2RSC3",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 192,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6205 2RSC",
    "monto": 25320.0,
    "monto_iva": 4810.8,
    "monto_total": 30130.8,
    "fecha": "2025-11-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3614936",
    "pn": "6205-2RC3",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 193,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "MICRO SWITCH 3P CON ROLDANA",
    "monto": 8391.596638655463,
    "monto_iva": 1594.4033613445379,
    "monto_total": 9986.0,
    "fecha": "2025-11-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "VITEL ENERGIA",
    "nFactura": "1372767",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 194,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CARGADOR DE BATERIA 12V",
    "monto": 84025.0,
    "monto_iva": 15964.75,
    "monto_total": 99989.75,
    "fecha": "2025-12-02",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "FERRETERIA IND. HERRAM SPA",
    "nFactura": "11647",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 195,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CARGADOR DE BATERIA 12V",
    "monto": 84025.0,
    "monto_iva": 15964.75,
    "monto_total": -99989.75,
    "fecha": "2025-12-05",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "FERRETERIA IND. HERRAM SPA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 196,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO HIDRAULICO",
    "monto": 38964.0,
    "monto_iva": 7403.16,
    "monto_total": 46367.16,
    "fecha": "2025-12-05",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MINING PARTS SPA",
    "nFactura": "16907",
    "pn": "HF6510",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 197,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA RR5700",
    "monto": 200000.0,
    "monto_iva": 38000.0,
    "monto_total": 238000.0,
    "fecha": "2025-12-09",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2095",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 198,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SEGURO CADENA",
    "monto": 93600.0,
    "monto_iva": 17784.0,
    "monto_total": 111384.0,
    "fecha": "2025-12-09",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DUCASSE",
    "nFactura": "1765446",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 199,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FUSIBLE ANL 150A",
    "monto": 11487.0,
    "monto_iva": 2182.53,
    "monto_total": 13669.53,
    "fecha": "2025-12-12",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MERCADO LIBRE CHILE LTDA",
    "nFactura": "11342822",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 200,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TAPA DEPOSITO REACH",
    "monto": 10542.0,
    "monto_iva": 2002.98,
    "monto_total": 12544.98,
    "fecha": "2025-12-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "CHILEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 201,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TAPA DEPOSITO REACH",
    "monto": 92000.0,
    "monto_iva": 17480.0,
    "monto_total": 109480.0,
    "fecha": "2025-12-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "EMPRESAS GH SERVICIOS LTDA",
    "nFactura": "10621",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 202,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SOLENOIDE 24V / 200 A (ZM 404)",
    "monto": 62631.0,
    "monto_iva": 11899.89,
    "monto_total": 74530.89,
    "fecha": "2025-12-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "REPUESTO AUTOMOTRICES LTDA",
    "nFactura": "656677",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 203,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO ACEITE B113",
    "monto": 7034.0,
    "monto_iva": 1336.46,
    "monto_total": 8370.46,
    "fecha": "2025-12-16",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "CENTRAL FILTROS EIRL",
    "nFactura": "241233",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 204,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6305 2RSC",
    "monto": 21600.0,
    "monto_iva": 4104.0,
    "monto_total": 25704.0,
    "fecha": "2025-12-16",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3618967",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 205,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LLAVE DE CHAPAS TRANSPALETA 8400",
    "monto": 10084.0,
    "monto_iva": 1915.96,
    "monto_total": 11999.96,
    "fecha": "2025-12-18",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "VICTOR HUGO ACUÑA SEPULVEDA",
    "nFactura": "B-3286",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 206,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA REACH RAYMOND R40TT",
    "monto": 200000.0,
    "monto_iva": 38000.0,
    "monto_total": 238000.0,
    "fecha": "2025-12-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2105",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 207,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS CASTER TRANSPALETA 8400",
    "monto": 100000.0,
    "monto_iva": 19000.0,
    "monto_total": 119000.0,
    "fecha": "2025-12-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2105",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 208,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER STARCKER ELECTRICA PULMAHUE S/N",
    "monto": 140000.0,
    "monto_iva": 26600.0,
    "monto_total": 166600.0,
    "fecha": "2025-12-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2105",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 209,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA MOTRIZ STARCKER ELECTRICA PULMAHUE S/N",
    "monto": 150000.0,
    "monto_iva": 28500.0,
    "monto_total": 178500.0,
    "fecha": "2025-12-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2105",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 210,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER REACH RAYMOND",
    "monto": 90000.0,
    "monto_iva": 17100.0,
    "monto_total": 107100.0,
    "fecha": "2025-12-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2105",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 211,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ADUANA SENSORES BT",
    "monto": 15825.0,
    "monto_iva": 3006.75,
    "monto_total": 0.0,
    "fecha": "2025-12-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DHL EXPRESS",
    "nFactura": "4633962",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 212,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA 174 KS/85/074/076/13 VULKOLLAN",
    "monto": 147657.0,
    "monto_iva": 28054.83,
    "monto_total": 175711.83000000002,
    "fecha": "2025-12-22",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19252",
    "pn": "572534700",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 213,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6305 2RSC",
    "monto": 27000.0,
    "monto_iva": 5130.0,
    "monto_total": 32130.0,
    "fecha": "2025-12-22",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3620128",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 214,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6305 2RSC",
    "monto": 31741.0,
    "monto_iva": 6030.79,
    "monto_total": 37770.0,
    "fecha": "2025-12-22",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 215,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RETEN MOTRIZ RUEDA JLG",
    "monto": 284672.0,
    "monto_iva": 54087.68,
    "monto_total": 338759.68,
    "fecha": "2025-12-23",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "23034",
    "pn": "270001739",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 216,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RETEN LADO MOTOR RUEDA JLG",
    "monto": 12623.2,
    "monto_iva": 2398.4080000000004,
    "monto_total": 15021.608,
    "fecha": "2025-12-23",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "23034",
    "pn": "1724786",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 217,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ORING TAPA MOTOR RUEDA JLG",
    "monto": 4319.2,
    "monto_iva": 820.648,
    "monto_total": 5139.848,
    "fecha": "2025-12-23",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "23034",
    "pn": "370000191",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 218,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "MONTAJE RUEDA TRACCION RAYMOND R40TT",
    "monto": 10000.0,
    "monto_iva": 1900.0,
    "monto_total": 11900.0,
    "fecha": "2025-12-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "STRANKA",
    "nFactura": "3301",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 219,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SEGURO CADENA",
    "monto": 42216.0,
    "monto_iva": 0.0,
    "monto_total": 0.0,
    "fecha": "2025-12-29",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 220,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TAPA DEPOSITO REACH",
    "monto": 305160.0,
    "monto_iva": 57980.4,
    "monto_total": 363140.4,
    "fecha": "2025-12-30",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "EMPRESAS GH SERVICIOS LTDA",
    "nFactura": "10671",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 221,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CABLE DRIVE",
    "monto": 175888.0,
    "monto_iva": 33418.72,
    "monto_total": 209306.72,
    "fecha": "2025-12-30",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "23130",
    "pn": "1-1001091502",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 222,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FLETE REPUESTOS COQUMBO",
    "monto": 8362.0,
    "monto_iva": 1588.78,
    "monto_total": 9950.78,
    "fecha": "2026-01-05",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "FEDEX LTDA",
    "nFactura": "b-10999463",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 223,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "200 LLAVEROS  RFID 1,56 MHZ (AB003 keyfob, blue, with F08 chip",
    "monto": 170589.0,
    "monto_iva": 32411.91,
    "monto_total": 203000.91,
    "fecha": "2026-01-06",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ING. MCI LTDA",
    "nFactura": "79025",
    "pn": "25070380906",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 224,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "NOTEBOOK",
    "monto": 336118.0,
    "monto_iva": 63862.42,
    "monto_total": 399980.42,
    "fecha": "2026-01-06",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ZETA TECH",
    "nFactura": "936",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 225,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "EMPAQUETADURA CULATA METALICA",
    "monto": 25238.0,
    "monto_iva": 4795.22,
    "monto_total": 30033.22,
    "fecha": "2026-01-09",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "6320",
    "pn": "EF02-J10",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 226,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "EMPAQUETADURA MULTIPLE ADM Y ESCAPE",
    "monto": 8193.0,
    "monto_iva": 1556.67,
    "monto_total": 9749.67,
    "fecha": "2026-01-09",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "6320",
    "pn": "EF10-J01",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 227,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TAPAS EQUIPO BT",
    "monto": 87838.0,
    "monto_iva": 16689.22,
    "monto_total": 104527.22,
    "fecha": "2026-01-12",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "73153",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 228,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TAPAS EQUIPO BT",
    "monto": 171000.0,
    "monto_iva": 32490.0,
    "monto_total": 203490.0,
    "fecha": "2026-01-12",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "73153",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 229,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA TRACCION REACH R40TT",
    "monto": 250000.0,
    "monto_iva": 47500.0,
    "monto_total": 297500.0,
    "fecha": "2026-01-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2117",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 230,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER REACH R40TT",
    "monto": 180000.0,
    "monto_iva": 34200.0,
    "monto_total": 214200.0,
    "fecha": "2026-01-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2117",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 231,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA REACH RR5700",
    "monto": 200000.0,
    "monto_iva": 38000.0,
    "monto_total": 238000.0,
    "fecha": "2026-01-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2117",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 232,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER PE4500",
    "monto": 70000.0,
    "monto_iva": 13300.0,
    "monto_total": 83300.0,
    "fecha": "2026-01-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2117",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 233,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE",
    "monto": 26494.0,
    "monto_iva": 5033.86,
    "monto_total": 31527.86,
    "fecha": "2026-01-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "CENTRAL FILTROS",
    "nFactura": "242115",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 234,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE",
    "monto": 5361.0,
    "monto_iva": 1018.59,
    "monto_total": 6379.59,
    "fecha": "2026-01-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "CENTRAL FILTROS",
    "nFactura": "242115",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 235,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS 6205 2RSC3",
    "monto": 27600.0,
    "monto_iva": 5244.0,
    "monto_total": 32844.0,
    "fecha": "2026-01-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3623673",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 236,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE 154051765 A029",
    "monto": 40950.0,
    "monto_iva": 7780.5,
    "monto_total": 48730.5,
    "fecha": "2026-01-21",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "73386",
    "pn": "86849",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 237,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE B033",
    "monto": 6459.0,
    "monto_iva": 1227.21,
    "monto_total": 7686.21,
    "fecha": "2026-01-21",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "73386",
    "pn": "105503",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 238,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ENCHUFE MACHO 2P+T 16A",
    "monto": 3580.0,
    "monto_iva": 680.2,
    "monto_total": 4260.2,
    "fecha": "2026-01-22",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "FERRETERIA VERONICA LARRAIN LTDA",
    "nFactura": "b-307171",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 239,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LLAVE DE CHAPAS JLG",
    "monto": 2000.0,
    "monto_iva": 380.0,
    "monto_total": 2380.0,
    "fecha": "2026-01-22",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "VICTOR HUGO ACUÑA SEPULVEDA",
    "nFactura": "b-000001",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 240,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "DISCOS FRENO MOTOR REACH",
    "monto": 90000.0,
    "monto_iva": 17100.0,
    "monto_total": 107100.0,
    "fecha": "2026-01-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MECANICA DE MAQUINAS Y MANTENCIONES SEBASTIAN PEÑA SPA",
    "nFactura": "79",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 241,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "KIT CONTACTOR 1-105-129-111",
    "monto": 332331.0,
    "monto_iva": 63142.89,
    "monto_total": 395473.89,
    "fecha": "2026-01-26",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RPARTS (RENTAL PATAGONIA)",
    "nFactura": "863",
    "pn": "1105129111",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 242,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LLAVE CHAPA JLG",
    "monto": 6000.0,
    "monto_iva": 1140.0,
    "monto_total": 7140.0,
    "fecha": "2026-01-28",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "VICTOR HUGO ACUÑA SEPULVEDA",
    "nFactura": "b-000002",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 243,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LLAVE REACH RAYMOND",
    "monto": 12000.0,
    "monto_iva": 2280.0,
    "monto_total": 14280.0,
    "fecha": "2026-01-28",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "VICTOR HUGO ACUÑA SEPULVEDA",
    "nFactura": "b-000003",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 244,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SENSOR CAPTADOR ANGULO SR/ 2509170032",
    "monto": 383126.0,
    "monto_iva": 72793.94,
    "monto_total": 455919.94,
    "fecha": "2026-02-02",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "HAULOTTE CHILE",
    "nFactura": "7570",
    "pn": "4000327290",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 245,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PERNOS PARA CALUGA DE PARADA DE EMERGENCIA",
    "monto": 2857.2000000000003,
    "monto_iva": 542.868,
    "monto_total": 3400.068,
    "fecha": "2026-02-04",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "CASA DEL PERNO",
    "nFactura": "B-5970493",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 246,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER 150/050/5/25 (STILL)",
    "monto": 71430.0,
    "monto_iva": 13571.7,
    "monto_total": 85001.7,
    "fecha": "2026-02-06",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19536",
    "pn": "575030021",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 247,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6006 2RS",
    "monto": 8600.0,
    "monto_iva": 1634.0,
    "monto_total": 10234.0,
    "fecha": "2026-02-10",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3629408",
    "pn": "6006",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 248,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6204 2RSC",
    "monto": 7200.0,
    "monto_iva": 1368.0,
    "monto_total": 8568.0,
    "fecha": "2026-02-10",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3629408",
    "pn": "6204",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 249,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6305",
    "monto": 24700.0,
    "monto_iva": 4693.0,
    "monto_total": 29393.0,
    "fecha": "2026-02-10",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3629408",
    "pn": "6305",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 250,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "KIT SELLO JLG 7019673",
    "monto": 80520.0,
    "monto_iva": 15298.8,
    "monto_total": 95818.8,
    "fecha": "2026-02-11",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74023",
    "pn": "7019673",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 251,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CHAVETA REACH R40TT 102044904",
    "monto": 12840.0,
    "monto_iva": 2439.6,
    "monto_total": 15279.6,
    "fecha": "2026-02-11",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74024",
    "pn": "102044904",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 252,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CORREA DISTRIBUCIÓN 51468147",
    "monto": 64980.0,
    "monto_iva": 12346.2,
    "monto_total": 77326.2,
    "fecha": "2026-02-11",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74025",
    "pn": "51468147",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 253,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TENSOR CORREA GRUA H. 110D-7E, 3976834",
    "monto": 253430.0,
    "monto_iva": 48151.7,
    "monto_total": 301581.7,
    "fecha": "2026-02-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "CLEMSA S.A",
    "nFactura": "103787",
    "pn": "XKDE-02670",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 254,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "REFRIGERANTE 50/50 , 20 LTS",
    "monto": 32765.0,
    "monto_iva": 6225.35,
    "monto_total": 38990.35,
    "fecha": "2026-02-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "IMPLEMENTOS S.A",
    "nFactura": "6324723",
    "pn": "SUNAC0006",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 255,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS LM3000849/11 (RUEDAS LINDE)",
    "monto": 55200.0,
    "monto_iva": 10488.0,
    "monto_total": 65688.0,
    "fecha": "2026-02-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMIENTOS CHACABUCO LTDA",
    "nFactura": "81697",
    "pn": "LM300849/11 - KOYO",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 256,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CORREA OPTIBELT 8PK1750 (ACCESORIO GRUA HYINDAI 110D-7E), 3289930",
    "monto": 20974.0,
    "monto_iva": 3985.06,
    "monto_total": 24959.06,
    "fecha": "2026-02-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMIENTOS Y REPUESTOS GECA LTDA",
    "nFactura": "4364",
    "pn": "8PK1750",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 257,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOMBA DE AGUA GRUA HORQUILLA 110D-7E 5473238",
    "monto": 43350.0,
    "monto_iva": 8236.5,
    "monto_total": 51586.5,
    "fecha": "2026-02-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SURAC SPA",
    "nFactura": "395922",
    "pn": "2881804",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 258,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CORREA OPTIBELT ALPJA LINEAR 5M-15 (CORTADA A 10 MM ANCHO) 3 MTS",
    "monto": 33503.0,
    "monto_iva": 6365.57,
    "monto_total": 39868.57,
    "fecha": "2026-02-16",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "TECNICOR",
    "nFactura": "3621190",
    "pn": "240200",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 259,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6205-2RS",
    "monto": 24872.0,
    "monto_iva": 4725.68,
    "monto_total": 29597.68,
    "fecha": "2026-02-16",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMIENTOS Y REPUESTOS GECA LTDA",
    "nFactura": "4388",
    "pn": "6205",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 260,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "buje para rueda caster still",
    "monto": 15000.0,
    "monto_iva": 2850.0,
    "monto_total": 17850.0,
    "fecha": "2026-02-16",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "TORNERO",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 261,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "SERVICIO CONTABILIDAD",
    "monto": 1949738.0,
    "monto_iva": 370450.22000000003,
    "monto_total": 0.0,
    "fecha": "2026-02-18",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "FINANCIAL OPTION AUDITORES CONSULTORES LTDA",
    "nFactura": "2727",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 262,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TAPA RADIADOR CENTURY CER-219",
    "monto": 6930.0,
    "monto_iva": 1316.7,
    "monto_total": 8246.7,
    "fecha": "2026-02-18",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "90970",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 263,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOBINA CONTROL (BAJADA)",
    "monto": 80198.0,
    "monto_iva": 15237.62,
    "monto_total": 95435.62,
    "fecha": "2026-02-18",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "23356",
    "pn": "70000799",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 264,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER TRANSPALETA PE4500",
    "monto": 70000.0,
    "monto_iva": 13300.0,
    "monto_total": 83300.0,
    "fecha": "2026-02-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2144",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 265,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA TRANSPALETA 8400",
    "monto": 90000.0,
    "monto_iva": 17100.0,
    "monto_total": 107100.0,
    "fecha": "2026-02-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2144",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 266,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER BT LPE200",
    "monto": 100000.0,
    "monto_iva": 19000.0,
    "monto_total": 119000.0,
    "fecha": "2026-02-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2144",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 267,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "MUEBLE ESCRITORIO",
    "monto": 29411.764705882353,
    "monto_iva": 5588.235294117647,
    "monto_total": 35000.0,
    "fecha": "2026-02-19",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "FACEBOOK",
    "nFactura": "-",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 268,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "INSUMOS OFICINA Y TALLER",
    "monto": 16974.0,
    "monto_iva": 3225.06,
    "monto_total": 20199.06,
    "fecha": "2026-02-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "FERNAPET",
    "nFactura": "75790",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 269,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CABLE DRIVE",
    "monto": 251100.0,
    "monto_iva": 47709.0,
    "monto_total": 298809.0,
    "fecha": "2026-02-20",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "23359",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 270,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE AFM-080493",
    "monto": 52000.0,
    "monto_iva": 9880.0,
    "monto_total": 61880.0,
    "fecha": "2026-02-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "FILTROS MARTICORENA S.A",
    "nFactura": "50668",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 271,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6206 2RS",
    "monto": 13200.0,
    "monto_iva": 2508.0,
    "monto_total": 15708.0,
    "fecha": "2026-02-25",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3632088",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 272,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6305 2RS",
    "monto": 25300.0,
    "monto_iva": 4807.0,
    "monto_total": 30107.0,
    "fecha": "2026-02-25",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3632088",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 273,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO 6205 2RS",
    "monto": 32200.0,
    "monto_iva": 6118.0,
    "monto_total": 38318.0,
    "fecha": "2026-02-25",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3632088",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 274,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA TRACCION ETV 214 JUNGHEINRICH",
    "monto": 220000.0,
    "monto_iva": 41800.0,
    "monto_total": 261800.0,
    "fecha": "2026-02-25",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2150",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 275,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CERRADURA PARA BODEGA",
    "monto": 4000.0,
    "monto_iva": 760.0,
    "monto_total": 4760.0,
    "fecha": "2026-03-01",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "FERIA",
    "nFactura": "-",
    "pn": "-",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 276,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE 154051765 A029",
    "monto": 2153.0,
    "monto_iva": 409.07,
    "monto_total": 2562.07,
    "fecha": "2026-03-02",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74538",
    "pn": "86849",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 277,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE TRANSMISION",
    "monto": 3264.0,
    "monto_iva": 620.16,
    "monto_total": 3884.16,
    "fecha": "2026-03-02",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74538",
    "pn": "115100",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 278,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE A015",
    "monto": 1913.0,
    "monto_iva": 363.47,
    "monto_total": 2276.4700000000003,
    "fecha": "2026-03-02",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74538",
    "pn": "85221",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 279,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO TRANSIMISIÓN (SUCCION C/BASE) A080",
    "monto": 32805.0,
    "monto_iva": 6232.95,
    "monto_total": 39037.95,
    "fecha": "2026-03-02",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74538",
    "pn": "106654",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 280,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA REACH RAYMOND R40TT",
    "monto": 200000.0,
    "monto_iva": 38000.0,
    "monto_total": 238000.0,
    "fecha": "2026-03-04",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2160",
    "pn": "2160",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 281,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA TRANSPALETA 8400",
    "monto": 270000.0,
    "monto_iva": 51300.0,
    "monto_total": 321300.0,
    "fecha": "2026-03-04",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2160",
    "pn": "2160",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 282,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER TRANSPALETA RAYMOND",
    "monto": 60000.0,
    "monto_iva": 11400.0,
    "monto_total": 71400.0,
    "fecha": "2026-03-04",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2160",
    "pn": "2160",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 283,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FOCO FAENA LMR42RW 14 LED 10-48V 42W",
    "monto": 50408.0,
    "monto_iva": 9577.52,
    "monto_total": 59985.520000000004,
    "fecha": "2026-03-03",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "COMERCIAL EKAR SPA",
    "nFactura": "7027",
    "pn": "33309",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 284,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "MOTOR DE ARRANQUE STILL RC40-30, NISSAN K25",
    "monto": 46219.0,
    "monto_iva": 8781.61,
    "monto_total": 55000.0,
    "fecha": "2026-03-04",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "REPUESTOS CK MOTORS",
    "nFactura": "3",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 285,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RECAUCHAJE RUEDAS JLG 1930ES",
    "monto": 216000.0,
    "monto_iva": 41040.0,
    "monto_total": 257040.0,
    "fecha": "2026-03-07",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "COMERCIO, DESARROLLO E ING SPA",
    "nFactura": "467",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 286,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "GM BL566 MAX CADENA 5/8\" GRUA HORQUILLA",
    "monto": 159000.0,
    "monto_iva": 30210.0,
    "monto_total": 189210.0,
    "fecha": "2026-03-10",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3634810",
    "pn": "EES000566BL0X",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 287,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA TRACCION ETV 214 JUNGHEINRICH",
    "monto": 220000.0,
    "monto_iva": 41800.0,
    "monto_total": 261800.0,
    "fecha": "2026-03-11",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2170",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 288,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA + RODAMIENTO ETV214 JUNGH",
    "monto": 460000.0,
    "monto_iva": 87400.0,
    "monto_total": 547400.0,
    "fecha": "2026-03-11",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2170",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 289,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TAPA PROTECCION JUNGHEINRICH ETV214",
    "monto": 81000.0,
    "monto_iva": 15390.0,
    "monto_total": 96390.0,
    "fecha": "2026-03-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "74810",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 290,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER TRANSPALETA RAYMOND 8400",
    "monto": 60000.0,
    "monto_iva": 11400.0,
    "monto_total": 71400.0,
    "fecha": "2026-03-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2171",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 291,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "KIT REPARACION EQUIPO DE GAS NIKKY 16310-GW54A",
    "monto": 153324.0,
    "monto_iva": 29131.56,
    "monto_total": 182455.56,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "107365",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 292,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CABLE BUJIA",
    "monto": 11962.0,
    "monto_iva": 2272.78,
    "monto_total": 14234.78,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "135716",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 293,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE ACEITE",
    "monto": 2978.0,
    "monto_iva": 565.82,
    "monto_total": 3543.82,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "99899",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 294,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO TRANSMISION",
    "monto": 3523.0,
    "monto_iva": 669.37,
    "monto_total": 4192.37,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "102118",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 295,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO DE AIRE",
    "monto": 25482.0,
    "monto_iva": 4841.58,
    "monto_total": 30323.58,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "40295",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 296,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CORREA AUXILIAR",
    "monto": 4626.0,
    "monto_iva": 878.94,
    "monto_total": 5504.9400000000005,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "24888",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 297,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "EMPAQUETADURA BASE BOMBA DE AGUA (BLOCK)",
    "monto": 10637.0,
    "monto_iva": 2021.03,
    "monto_total": 12658.03,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "92687",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 298,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO AIRE TOYOTA 32-8FG20 (308FG25)",
    "monto": 100230.0,
    "monto_iva": 19043.7,
    "monto_total": 119273.7,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "89189",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 299,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO MOTOR S/B 230415-3 TOYOTA 32-8FG20 (308FG25)",
    "monto": 9252.0,
    "monto_iva": 1757.88,
    "monto_total": 11009.880000000001,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "91575",
    "pn": "86849",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 300,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CHAPA CONTACTO GRUA HORQUILLA STILL RC40-30",
    "monto": 16258.0,
    "monto_iva": 3089.02,
    "monto_total": 19347.02,
    "fecha": "2026-03-12",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "7456",
    "pn": "LB30-J08",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 301,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "KIT CONTACTOR 1-105-129-111",
    "monto": 253018.0,
    "monto_iva": 48073.42,
    "monto_total": 301091.42,
    "fecha": "2026-05-06",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MAQUIPARTS SPA",
    "nFactura": "93192",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 302,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS 6205-2RS",
    "monto": 42000.0,
    "monto_iva": 7980.0,
    "monto_total": 49980.0,
    "fecha": "2026-03-13",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3635534",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 303,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BL566 MAX UNION CLIP",
    "monto": 4800.0,
    "monto_iva": 912.0,
    "monto_total": 5712.0,
    "fecha": "2026-03-13",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3635534",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 304,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ENVÍO JOYSTICK ANTOFAGASTA",
    "monto": 6437.0,
    "monto_iva": 1223.03,
    "monto_total": 7660.03,
    "fecha": "2026-03-16",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "STARKEN",
    "nFactura": "13357806",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 305,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOLSA ZIPPER 10X16",
    "monto": 3535.0,
    "monto_iva": 671.65,
    "monto_total": 4206.65,
    "fecha": "2026-03-17",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "COMERCIALIZADORA LARAPLAS SPA",
    "nFactura": "2960",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 306,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOLSA CTA ALTA 4OX50",
    "monto": 2794.0,
    "monto_iva": 530.86,
    "monto_total": 3324.86,
    "fecha": "2026-03-17",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "COMERCIALIZADORA LARAPLAS SPA",
    "nFactura": "2960",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 307,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILM STRECH 50 NEGRO",
    "monto": 5682.0,
    "monto_iva": 1079.58,
    "monto_total": 6761.58,
    "fecha": "2026-03-17",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "COMERCIALIZADORA LARAPLAS SPA",
    "nFactura": "2960",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 308,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILM STRECH 50 BLANCO",
    "monto": 4700.0,
    "monto_iva": 893.0,
    "monto_total": 5593.0,
    "fecha": "2026-03-17",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "COMERCIALIZADORA LARAPLAS SPA",
    "nFactura": "2960",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 309,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CINTA EMBALAJE",
    "monto": 2720.0,
    "monto_iva": 516.8,
    "monto_total": 3236.8,
    "fecha": "2026-03-17",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "COMERCIALIZADORA LARAPLAS SPA",
    "nFactura": "2960",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 310,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ROLLO DE PAPEL DE 40 CM",
    "monto": 13998.0,
    "monto_iva": 2659.62,
    "monto_total": 16657.62,
    "fecha": "2026-03-17",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "COMERCIALIZADORA LARAPLAS SPA",
    "nFactura": "2960",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 311,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS MASTIL 50052382",
    "monto": 139500.0,
    "monto_iva": 26505.0,
    "monto_total": 166005.0,
    "fecha": "2026-03-25",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "75184",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 312,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS JLG 1930ES",
    "monto": 443734.0,
    "monto_iva": 84309.46,
    "monto_total": 528043.46,
    "fecha": "2026-03-14",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SKY RENTAL",
    "nFactura": "23670",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 313,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS RECAUCHADAS JLG 1930 ES",
    "monto": 216000.0,
    "monto_iva": 41040.0,
    "monto_total": 257040.0,
    "fecha": "2026-03-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "COMERCIO, DESARROLLO E ING SPA",
    "nFactura": "476",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 314,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RETEN 50 80/8 (RUEDA CARGA LINDE)",
    "monto": 9184.0,
    "monto_iva": 1744.96,
    "monto_total": 10928.96,
    "fecha": "2026-03-18",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "674028",
    "pn": "TTO G014",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 315,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS CASTER PE 4500 - RAY 8000",
    "monto": 180000.0,
    "monto_iva": 34200.0,
    "monto_total": 214200.0,
    "fecha": "2026-03-18",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALEX MARAMBIO FARIAS",
    "nFactura": "2176",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 316,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE GARGA 174 KS/85/074/076/13 (BT)",
    "monto": 147656.0,
    "monto_iva": 28054.64,
    "monto_total": 175710.64,
    "fecha": "2026-03-19",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19768",
    "pn": "572534700",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 317,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FABRICACION BUJE PARA RUEDA EGV14 STILL",
    "monto": 15000.0,
    "monto_iva": 2850.0,
    "monto_total": 17850.0,
    "fecha": "2026-03-22",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MECANICA DE MAQUINAS Y MANTENCIONES SEBASTIAN PEÑA SPA",
    "nFactura": "89",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 318,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "REPARACION CADENAS JUNGHEINRICH",
    "monto": 50000.0,
    "monto_iva": 9500.0,
    "monto_total": 59500.0,
    "fecha": "2026-03-22",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MECANICA DE MAQUINAS Y MANTENCIONES SEBASTIAN PEÑA SPA",
    "nFactura": "89",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 319,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO TRANSMISION GRUA STILL 9852675",
    "monto": 26030.0,
    "monto_iva": 4945.7,
    "monto_total": 30975.7,
    "fecha": "2026-04-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "DEREMAQ",
    "nFactura": "75813",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 320,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOMBA LEVANTE TSP-6000 EQUIPO CROWN",
    "monto": 1600000.0,
    "monto_iva": 304000.0,
    "monto_total": 1904000.0,
    "fecha": "2026-03-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "248",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 321,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RETEN TTO C701 27-37-7",
    "monto": 3361.0,
    "monto_iva": 638.59,
    "monto_total": 3999.59,
    "fecha": "2026-03-25",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "674711",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 322,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TRABAJO PIÑON EJE MOTRIZ",
    "monto": 30000.0,
    "monto_iva": 5700.0,
    "monto_total": 35700.0,
    "fecha": "2026-03-30",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "BY METAL SPA",
    "nFactura": "2764",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 323,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "REGISTRO MARCA INAPI \"INMALUCA\"",
    "monto": 139778.0,
    "monto_iva": 26557.82,
    "monto_total": 166335.82,
    "fecha": "2026-04-03",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "TESORERIA GENERAL DE LA REPUBLICA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 324,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FILTRO HIDRAULICO HF6056",
    "monto": 36795.0,
    "monto_iva": 6991.05,
    "monto_total": 43786.05,
    "fecha": "2026-04-02",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MINING PARTS SPA",
    "nFactura": "18536",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 325,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PILAS AAA (PAR), TECLADO",
    "monto": 2101.0,
    "monto_iva": 399.19,
    "monto_total": 2500.19,
    "fecha": "2026-04-01",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "CASA DEL PERNO",
    "nFactura": "B-117213",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 326,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ENCHUFE ANDERSON 175A",
    "monto": 30218.48,
    "monto_iva": 5741.5112,
    "monto_total": 35959.9912,
    "fecha": "2026-04-08",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "YEMIN SPA",
    "nFactura": "4208",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 327,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "MATERIALES DE OFICINA",
    "monto": 23671.0,
    "monto_iva": 4497.49,
    "monto_total": 28168.489999999998,
    "fecha": "2026-04-10",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "LIBRERÍA NACIONAL-ARTEL S.A",
    "nFactura": "1184779",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 328,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CHAPAS ITALIANA",
    "monto": 190000.0,
    "monto_iva": 36100.0,
    "monto_total": 226100.0,
    "fecha": "2026-04-13",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SCARLET DEL CARMEN QUINTEROS AHUMADA",
    "nFactura": "1610",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 329,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "NEUMATICOS CROWN SC4200",
    "monto": 250000.0,
    "monto_iva": 47500.0,
    "monto_total": 297500.0,
    "fecha": "2026-04-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "249",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 330,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTO TIM LM501349",
    "monto": 42560.0,
    "monto_iva": 8086.400000000001,
    "monto_total": 50646.4,
    "fecha": "2026-04-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "676886",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 331,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CUBETA RODAMIENTO TIM LM501310",
    "monto": 12616.0,
    "monto_iva": 2397.04,
    "monto_total": 15013.04,
    "fecha": "2026-04-15",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ROSSIER LTDA",
    "nFactura": "676886",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 332,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RODAMIENTOS 6305 2rs",
    "monto": 39610.0,
    "monto_iva": 7525.9,
    "monto_total": 47135.9,
    "fecha": "2026-04-17",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODAMENDEZ LTDA",
    "nFactura": "3642126",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 333,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA 174 KS 85/074/076/13",
    "monto": 151308.0,
    "monto_iva": 28748.52,
    "monto_total": 180056.52,
    "fecha": "2026-04-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19989",
    "pn": "5725347000",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 334,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA DE CARGA 85/080/082/17",
    "monto": 159644.0,
    "monto_iva": 30332.36,
    "monto_total": 189976.36,
    "fecha": "2026-04-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19989",
    "pn": "5720369000",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 335,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER Ø 140 X 60 (140/054/100/5/20",
    "monto": 44973.0,
    "monto_iva": 8544.87,
    "monto_total": 53517.87,
    "fecha": "2026-04-20",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ILASA SPA",
    "nFactura": "19989",
    "pn": "5712027500",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 336,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FUSIBLES VIDRIO 5A, 10A, 15A",
    "monto": 5042.0,
    "monto_iva": 957.98,
    "monto_total": 5999.98,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "MANUAL RICARDO SAN MARTIN TAPIA",
    "nFactura": "1968",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 337,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LAINA DONATO DE AJUSTE 40X25",
    "monto": 18000.0,
    "monto_iva": 3420.0,
    "monto_total": 21420.0,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "202375",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 338,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LAINA DONATO DE AJUSTE 33X20",
    "monto": 11520.0,
    "monto_iva": 2188.8,
    "monto_total": 13708.8,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "202375",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 339,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "LAINA 0,2 MM 25X41",
    "monto": 3916.7799999999997,
    "monto_iva": 744.1881999999999,
    "monto_total": 4660.968199999999,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "202375",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 340,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PASADOR ELASTICO 5X40",
    "monto": 3095.7,
    "monto_iva": 588.183,
    "monto_total": 3683.883,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "202375",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 341,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PASADOR ELASTICO 8X60",
    "monto": 3226.88,
    "monto_iva": 613.1072,
    "monto_total": 3839.9872,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "202375",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 342,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PASADOR ELASTICO 5X60",
    "monto": 1039.04,
    "monto_iva": 197.4176,
    "monto_total": 1236.4576,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "UNIPER LTDA",
    "nFactura": "202375",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 343,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "GRASA LIQUIDA",
    "monto": 5042.0,
    "monto_iva": 957.98,
    "monto_total": 5999.98,
    "fecha": "2026-04-22",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "GUILLERMO ZAPEDA GONZALEZ",
    "nFactura": "B-16609",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 344,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "JUEGO RUEDAS APILADOR RR5700 CROWN",
    "monto": 600000.0,
    "monto_iva": 114000.0,
    "monto_total": 714000.0,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "254",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 345,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PARKER 8X40",
    "monto": 1008.0,
    "monto_iva": 191.52,
    "monto_total": 1199.52,
    "fecha": "2026-04-22",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "INVERSIONES SCREW CHILE SPA",
    "nFactura": "22926",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 346,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "GOTITA",
    "monto": 2941.0,
    "monto_iva": 558.79,
    "monto_total": 3499.79,
    "fecha": "2026-04-22",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "INVERSIONES SCREW CHILE SPA",
    "nFactura": "22926",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 347,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "TARRO AGOREX 120 CC",
    "monto": 2101.0,
    "monto_iva": 399.19,
    "monto_total": 2500.19,
    "fecha": "2026-04-21",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "INVERSIONES SCREW CHILE SPA",
    "nFactura": "22906",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 348,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "DESTORNILLADOR",
    "monto": 840.0,
    "monto_iva": 159.6,
    "monto_total": 999.6,
    "fecha": "2026-04-21",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "INVERSIONES SCREW CHILE SPA",
    "nFactura": "22906",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 349,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "PERNOS PARKER 5/16X2 1/2+G",
    "monto": 882.0,
    "monto_iva": 167.58,
    "monto_total": 1049.58,
    "fecha": "2026-04-21",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "INVERSIONES SCREW CHILE SPA",
    "nFactura": "22906",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 350,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA GOMA GRIS Ø 200X50 MOBIL",
    "monto": 33960.0,
    "monto_iva": 6452.4,
    "monto_total": 40412.4,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODANI SPA",
    "nFactura": "126891",
    "pn": "PR29200TPR",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 351,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA GOMA GRIS Ø 150 X 50 FIJA",
    "monto": 44360.0,
    "monto_iva": 8428.4,
    "monto_total": 52788.4,
    "fecha": "2026-04-24",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "RODANI SPA",
    "nFactura": "126891",
    "pn": "PR29150TPRF",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 352,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "MEJORA EN EJE PIÑON",
    "monto": 30000.0,
    "monto_iva": 5700.0,
    "monto_total": 35700.0,
    "fecha": "2026-04-30",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "BY METAL SPA",
    "nFactura": "2847",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 353,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FABRICACION 4 PERNOS ESP.",
    "monto": 20000.0,
    "monto_iva": 3800.0,
    "monto_total": 23800.0,
    "fecha": "2026-05-04",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MECÁNICA DE MAQUINAS Y MANTENCIONES\nSEBASTIÁN PEÑA SPA",
    "nFactura": "101",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 354,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "GRASERA RECTA 6",
    "monto": 3278.0,
    "monto_iva": 622.82,
    "monto_total": 3900.82,
    "fecha": "2026-05-04",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "INVERSIONES SCREW CHILE SPA",
    "nFactura": "23223",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 355,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FABRICACION BUJES UNIDAD DE FRENO",
    "monto": 15000.0,
    "monto_iva": 2850.0,
    "monto_total": 17850.0,
    "fecha": "2026-05-04",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "MECÁNICA DE MAQUINAS Y MANTENCIONES SEBASTIÁN PEÑA SPA",
    "nFactura": "101",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 356,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "BOCINA 48V",
    "monto": 39040.0,
    "monto_iva": 7417.6,
    "monto_total": 46457.6,
    "fecha": "2026-05-06",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "8468",
    "pn": "LC06-J03",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 357,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "ESPEJO RETROVISOR LATERAL 137X232",
    "monto": 10693.0,
    "monto_iva": 2031.67,
    "monto_total": 12724.67,
    "fecha": "2026-05-06",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "JORKLIFT SPA",
    "nFactura": "8468",
    "pn": "AA21-J02",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 358,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FUSIBLE MEGA 100A",
    "monto": 11748.0,
    "monto_iva": 2232.12,
    "monto_total": 13980.119999999999,
    "fecha": "2026-05-06",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SOLIOT SPA",
    "nFactura": "1783",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 359,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "FUSIBLE MEGA 150A",
    "monto": 11748.0,
    "monto_iva": 2232.12,
    "monto_total": 13980.119999999999,
    "fecha": "2026-05-06",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "SOLIOT SPA",
    "nFactura": "1783",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 360,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "Ravioli Enchufe DIN160 160A Hembra con MANILLA",
    "monto": 30353.0,
    "monto_iva": 5767.07,
    "monto_total": 36120.07,
    "fecha": "2026-05-07",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "YEMIN SPA",
    "nFactura": "4336",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 361,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "CAJAS ORGANIZADORAS Y PORTA NOTEBOOK",
    "monto": 41916.0,
    "monto_iva": 7964.04,
    "monto_total": 49880.04,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "IKSO  SPA",
    "nFactura": "804567",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 362,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS DE CARGA PE4500",
    "monto": 400000.0,
    "monto_iva": 76000.0,
    "monto_total": 476000.0,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "255",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 363,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS CASTER TRANSPALETA 8400 (NUEVAS ) NEGRA",
    "monto": 90000.0,
    "monto_iva": 17100.0,
    "monto_total": 107100.0,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "255",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 364,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER TRANSPALETA PE4500",
    "monto": 90000.0,
    "monto_iva": 17100.0,
    "monto_total": 107100.0,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "255",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 365,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA TRACCION PE4500",
    "monto": 250000.0,
    "monto_iva": 47500.0,
    "monto_total": 297500.0,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "255",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 366,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDAS CARGA REACH RR5700",
    "monto": 200000.0,
    "monto_iva": 38000.0,
    "monto_total": 238000.0,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "255",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 367,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA CASTER REACH RR5700",
    "monto": 120000.0,
    "monto_iva": 22800.0,
    "monto_total": 142800.0,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "255",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 368,
    "tipo": "compra",
    "subTipo": "nacional",
    "categoria": "Materiales e insumos",
    "descripcion": "RUEDA TRACCION REACH RR5700",
    "monto": 250000.0,
    "monto_iva": 47500.0,
    "monto_total": 297500.0,
    "fecha": "2026-05-08",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "SERV. MECANICA MANTENCION Y ARRIENDO DE GRUAS CECILIA VARAS",
    "nFactura": "255",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 369,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "TOOGLE SWITCH 2P, SIN RETORNO",
    "monto": 49640.0,
    "monto_iva": 0,
    "monto_total": 61183.0,
    "fecha": "2025-08-11",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "LQ25081105",
    "pn": "4360539",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 370,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "JOYSTICK HAULOTTE  COMPACT 10 (2901015000)",
    "monto": 150.0,
    "monto_iva": 0,
    "monto_total": 180000.0,
    "fecha": "2025-08-12",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "ALIBABA",
    "nFactura": "PI20250813GC",
    "pn": "2441305220",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 371,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "JOYSTICK JLG",
    "monto": 180.0,
    "monto_iva": 0,
    "monto_total": 210000.0,
    "fecha": "2025-08-12",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "ALIBABA",
    "nFactura": "PI20250813GC",
    "pn": "1001134438",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 372,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "CONECTOR 14 PIN, REDONDO JOYSTICK",
    "monto": 39000.0,
    "monto_iva": 0,
    "monto_total": 40053.0,
    "fecha": "2025-08-19",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "4461016",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 373,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "CORREA ANTIESTETICA 13\"",
    "monto": 68200.0,
    "monto_iva": 0,
    "monto_total": 78730.0,
    "fecha": "2025-08-19",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "4240147",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 374,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "FUSIBLE ANL 350A",
    "monto": 12808.0,
    "monto_iva": 0,
    "monto_total": 12808.0,
    "fecha": "2025-08-27",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 375,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "CODIFICADOR ENCODER 6206V",
    "monto": 151862.0,
    "monto_iva": 0,
    "monto_total": 151862.0,
    "fecha": "2025-09-02",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "146080-007",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 376,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "SOLENOIDE ESTABLE 200A / 24VCC",
    "monto": 25000.0,
    "monto_iva": 0,
    "monto_total": 38075.0,
    "fecha": "2025-09-30",
    "notas": "LUIS",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 377,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "ENCHUFE SMH MACHO 160A",
    "monto": 9702.0,
    "monto_iva": 0,
    "monto_total": 9702.0,
    "fecha": "2025-10-21",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 378,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "SENSORES TRANSPALETA BT",
    "monto": 134730.0,
    "monto_iva": 0,
    "monto_total": 134730.0,
    "fecha": "2025-11-03",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALIBABA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 379,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "ENCHUFE ANDERSON 350A / 600V",
    "monto": 15000.0,
    "monto_iva": 0,
    "monto_total": 15000.0,
    "fecha": "2025-12-03",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 380,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "SOLENOIDE ESTABLE 200A / 24VCC",
    "monto": 58941.0,
    "monto_iva": 0,
    "monto_total": 58941.0,
    "fecha": "2025-12-06",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "i500026639",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 381,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "SENSOR BT",
    "monto": 132300.0,
    "monto_iva": 0,
    "monto_total": 132300.0,
    "fecha": "2025-12-10",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALIBABA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 382,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "SEGURO CADENA",
    "monto": 116669.0,
    "monto_iva": 0,
    "monto_total": 116669.0,
    "fecha": "2025-12-11",
    "notas": "MARIO",
    "rutContraparte": "",
    "razonSocial": "ALIBABA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 383,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "ENCHUFE ANDERSON 350A / 600V",
    "monto": 49274.0,
    "monto_iva": 0,
    "monto_total": 49274.0,
    "fecha": "2025-12-12",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 384,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "ENCHUFE SBE 160 A, 150V, 2 AWG",
    "monto": 26657.0,
    "monto_iva": 0,
    "monto_total": 26657.0,
    "fecha": "2025-12-16",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 385,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "ENCHUFE REMA 160A HEMBRA",
    "monto": 38600.0,
    "monto_iva": 0,
    "monto_total": 45935.0,
    "fecha": "2025-12-22",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 386,
    "tipo": "compra",
    "subTipo": "importacion",
    "categoria": "Importaciones",
    "descripcion": "FUSIBLE ANL 300A",
    "monto": 6930.0,
    "monto_iva": 0,
    "monto_total": 6930.0,
    "fecha": "2026-01-29",
    "notas": "INMALUCA",
    "rutContraparte": "",
    "razonSocial": "ALIEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 387,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "SENSOR ENCODER 3",
    "monto": 962873,
    "monto_iva": 182946,
    "monto_total": 1145819.4,
    "fecha": "2026-04-01",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "2604004709.0",
    "pn": "CR132271",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 388,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "SENSOR MAGNETICO BARRA GUIA",
    "monto": 866844,
    "monto_iva": 164701,
    "monto_total": 1031544.6,
    "fecha": "2026-04-01",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "2604004709.0",
    "pn": "CR133103",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 389,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "CABLE DRIVE",
    "monto": 159930,
    "monto_iva": 30387,
    "monto_total": 190316.70479815695,
    "fecha": "2026-04-01",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / JLG",
    "nFactura": "24718418.0",
    "pn": "JL1001091502",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 390,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "SENSOR ENCODER 3",
    "monto": 1332034,
    "monto_iva": 253086,
    "monto_total": 1585120.395201843,
    "fecha": "2026-04-01",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "24718418.0",
    "pn": "CR132271",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 391,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "RODAMIENTO HYUNDAI",
    "monto": 58226,
    "monto_iva": 11063,
    "monto_total": 69289.43946119306,
    "fecha": "2026-04-05",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / HYUNDAI",
    "nFactura": "2604006959.0",
    "pn": "67FV21300",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 392,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "KIT CONTACTOR",
    "monto": 213526,
    "monto_iva": 40570,
    "monto_total": 254095.54579858884,
    "fecha": "2026-04-05",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "2604006959.0",
    "pn": "1105129111",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 393,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "SWITCH CROWN",
    "monto": 12296,
    "monto_iva": 2336,
    "monto_total": 14632.339589480434,
    "fecha": "2026-04-05",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "2604006959.0",
    "pn": "118901",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 394,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "ACTUADOR MICROINTERRUPTOR",
    "monto": 27011,
    "monto_iva": 5132,
    "monto_total": 32143.172212957026,
    "fecha": "2026-04-05",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "2604006959.0",
    "pn": "90787",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 395,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "DISTANCIADOR (GOLILLA) EJE DIRECCION",
    "monto": 5500,
    "monto_iva": 1045,
    "monto_total": 6545.144874919819,
    "fecha": "2026-04-05",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "2604006959.0",
    "pn": "771219",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 396,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "RESORTE COMPRESION (EJE DIRECCION REACH)",
    "monto": 11634,
    "monto_iva": 2210,
    "monto_total": 13844.180782552918,
    "fecha": "2026-04-05",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "2604006959.0",
    "pn": "830-160",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 397,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "SENSOR T° MAGNETICO RAYMOND",
    "monto": 120744,
    "monto_iva": 22941,
    "monto_total": 143684.77728030787,
    "fecha": "2026-04-05",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "2604006959.0",
    "pn": "828003420004",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 398,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "CARBON MOTOR SC4000",
    "monto": 320231,
    "monto_iva": 60844,
    "monto_total": 381074.5591857756,
    "fecha": "2026-04-09",
    "notas": "UPS",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "24754669.0",
    "pn": "AV140-07-012C",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 399,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "ANILLO REACH R40TT",
    "monto": 194604,
    "monto_iva": 36975,
    "monto_total": 231579.210050889,
    "fecha": "2026-04-09",
    "notas": "UPS",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "24754669.0",
    "pn": "RA400-149",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 400,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "CARBON MOTOR LEVANTE SC4000 (SET DE 4)",
    "monto": 352680,
    "monto_iva": 67009,
    "monto_total": 419689.3628902514,
    "fecha": "2026-04-09",
    "notas": "UPS",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "24754669.0",
    "pn": "CR113652",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 401,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "EJE DIRECCION REACH R40TT",
    "monto": 240015,
    "monto_iva": 45603,
    "monto_total": 285618.012801962,
    "fecha": "2026-04-09",
    "notas": "UPS",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "24754669.0",
    "pn": "RA828-013-690-001",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 402,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "ROTOR - UNIDAD FRENO REACH R40TT",
    "monto": 272359,
    "monto_iva": 51749,
    "monto_total": 324107.54544819123,
    "fecha": "2026-04-09",
    "notas": "UPS",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "24754669.0",
    "pn": "1024365-120",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 403,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "UNIDAD DE FRENO REACH R40TT",
    "monto": 766298,
    "monto_iva": 145597,
    "monto_total": 911895.0096229308,
    "fecha": "2026-04-09",
    "notas": "UPS",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "24754669.0",
    "pn": "1024365-001",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 404,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "KIT PLACAS DE FRENO",
    "monto": 164207,
    "monto_iva": 31199,
    "monto_total": 195405.9487887954,
    "fecha": "2026-04-24",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / HYUNDAI",
    "nFactura": "2604042753.0",
    "pn": "21858687",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 405,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "JUEGO CARBONES (SET DE 4)",
    "monto": 65321,
    "monto_iva": 12411,
    "monto_total": 77732.26790373487,
    "fecha": "2026-04-24",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / CROWN",
    "nFactura": "2604042753.0",
    "pn": "CR113652",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 406,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "JUEGO CARBONES (SET DE 4)",
    "monto": 71180,
    "monto_iva": 13524,
    "monto_total": 84704.23838506051,
    "fecha": "2026-04-24",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / RAYMOND",
    "nFactura": "2604042753.0",
    "pn": "RA570-236-514",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 407,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "PASADOR CONECTOR ENCHUFE",
    "monto": 13117,
    "monto_iva": 2492,
    "monto_total": 15608.889137296159,
    "fecha": "2026-04-24",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / JLG",
    "nFactura": "2604042753.0",
    "pn": "4460465",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 408,
    "tipo": "compra",
    "subTipo": "tvh",
    "categoria": "Importaciones",
    "descripcion": "PIOLA MANUAL",
    "monto": 129462,
    "monto_iva": 24598,
    "monto_total": 154059.7357851131,
    "fecha": "2026-04-24",
    "notas": "FEDEX",
    "rutContraparte": "",
    "razonSocial": "TVH / JLG",
    "nFactura": "2604042753.0",
    "pn": "1061036",
    "clienteFinal": "",
    "tipoDoc": "IMP"
  },
  {
    "id": 409,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "IMPUESTO JOYSTICK",
    "monto": 50542.0,
    "monto_iva": 0.0,
    "monto_total": 50542.0,
    "fecha": "2025-08-20",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "1077409",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 410,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "NO FACTURABLE",
    "monto": 100579.0,
    "monto_iva": 0.0,
    "monto_total": 100579.0,
    "fecha": "2025-08-20",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "1077409",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 411,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA SENSORES BT",
    "monto": 19049.52,
    "monto_iva": 3041.52,
    "monto_total": 19049.52,
    "fecha": "2025-11-11",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "DHL EXPRESS",
    "nFactura": "4602342",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 412,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA SENSORES BT (NO FACTURABLE)",
    "monto": 33918.0,
    "monto_iva": 0.0,
    "monto_total": 33918.0,
    "fecha": "2025-11-11",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "DHL EXPRESS",
    "nFactura": "4602342",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 413,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA RODAMIENTOS SKF",
    "monto": 11031.0,
    "monto_iva": 0.0,
    "monto_total": 11031.0,
    "fecha": "2025-12-05",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "DHL EXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 414,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA SENSORES BT",
    "monto": 18831.75,
    "monto_iva": 3006.75,
    "monto_total": 18831.75,
    "fecha": "2025-12-20",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "DHL EXPRESS",
    "nFactura": "4633962",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 415,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA SENSORES BT (NO FACTURABLE)",
    "monto": 33531.0,
    "monto_iva": 0.0,
    "monto_total": 33531.0,
    "fecha": "2025-12-20",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "DHL EXPRESS",
    "nFactura": "4633962",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 416,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "SEGURO CADENA",
    "monto": 42216.0,
    "monto_iva": 0.0,
    "monto_total": 42216.0,
    "fecha": "2025-12-29",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 417,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ENVÍO KIT CONTACTOR",
    "monto": 20509.0,
    "monto_iva": 0.0,
    "monto_total": 20509.0,
    "fecha": "2026-01-28",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "CHILEXPRESS",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 418,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA JOYSTICK JLG",
    "monto": 74758.0,
    "monto_iva": 0.0,
    "monto_total": 74758.0,
    "fecha": "2026-01-29",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "1101959",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 419,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA JOYSTICK HAULOTTE",
    "monto": 75130.0,
    "monto_iva": 4766.0,
    "monto_total": 75130.0,
    "fecha": "2026-03-31",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "1110742",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 420,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "ADUANA CONVERTOR",
    "monto": 163430.0,
    "monto_iva": 0.0,
    "monto_total": 163430.0,
    "fecha": "2026-04-13",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  },
  {
    "id": 421,
    "tipo": "compra",
    "subTipo": "courrier",
    "categoria": "Pago courier / despacho",
    "descripcion": "RUEDA STACKER ELECTRICA",
    "monto": 49980.0,
    "monto_iva": 0.0,
    "monto_total": 49980.0,
    "fecha": "2026-04-17",
    "notas": "",
    "rutContraparte": "",
    "razonSocial": "UPS CHILE LTDA",
    "nFactura": "",
    "pn": "",
    "clienteFinal": "",
    "tipoDoc": "FAC"
  }
];
